/*
    AUTOGENERATED - DO NOT EDIT: this file is auto-generated by the local type agent.
    @Copyright 2015 ORCA Intel orca-intel.com All Rights Reserved.
*/

RQImport = { };

RQImport.Import = function (credentials, helpers) {
    var exports        = {};
    var endpoint       = "https://www.tobook.com/Delta/RQueryRESTService/json/";
    var rqAPIKey       = "NO_API_KEY";
    var rqAuthToken    = "";
    var rqTimeout      = 600000;
    var rqTimeoutLong  = 1200000;

    var setAPIKey      = function(apiKey) {
        /* If running in app context, store registered APIKey. */
        if (window.RQueryRESTServiceHelper === undefined) {
            return;
        } else {
            RQueryRESTServiceHelper.RQueryAPIKey = apiKey;
        }
    };

    var getAPIKey      = function() {
        /* If running in app context, retrieve registered APIKey. */
        if (window.RQueryRESTServiceHelper === undefined) {
            return rqAPIKey;
        } else {
            return RQueryRESTServiceHelper.RQueryAPIKey;
        }
    };

    var setAuthToken   = function(authToken) {
        /* If running in app context, store registered AuthToken. */
        if (window.RQueryRESTServiceHelper === undefined) {
            return;
        } else {
            RQueryRESTServiceHelper.RQueryAuthToken = authToken;
        }
    };

    var getAuthToken   = function() {
        /* If running in app context, retrieve registered AuthToken. */
        if (window.RQueryRESTServiceHelper === undefined) {
            return rqAuthToken;
        } else {
            return RQueryRESTServiceHelper.RQueryAuthToken;
        }
    };

    var errorHandler   = function(serviceName, commandName, textStatus) {
        /* If running in app context, call into error handler. */
        if (window.RQueryRESTServiceHelper === undefined) {
            rqAuthToken = "";

            return;
        } else {
            if (textStatus == "timeout") {
                RQueryRESTServiceHelper.TimeoutHandler(
                     serviceName ,commandName
                );
            } else {
                RQueryRESTServiceHelper.NetworkErrorHandler(
                     serviceName ,commandName
                );
            }
        }
    };
    
    var resultHandler  = function(serviceName, commandName, rpcResult) {
        /*
            Convert WCF datetime initialisation strings to javascript date
            objects on the fly. This is done here rather than in
            RQueryRESTServiceHelper.js to expose it to the XDK/Mashery API
            bindings panel, which runs outside app context.
        */

        /* marshall date objects */
        var count = rpcResult.RQueryResult.length;
    
        for (var i=0; i < count; i++) {
            var row = rpcResult.RQueryResult[i];
        
            for (var field in row) {
                if (row.hasOwnProperty(field)) {
                    if (
                        row[field].length       >= 7
                    &&  row[field].substr(0, 6) == "\/Date("
                    ) {
                        var dateString = row[field].substr(
                             6
                            ,(row[field].length - 8)
                        );
                
                        var dateValue       = new Date(parseFloat(dateString));
                
                        row["date" + field] = dateValue;
                        row[field]          = dateValue.toString();
                    }
                }
            }
        }
        
        /* If running in app context, call into service handler. */
        if (window.RQueryRESTServiceHelper === undefined) {
            return rpcResult;
        } else {
            return RQueryRESTServiceHelper.ResultHandler(
                serviceName, commandName, rpcResult
            );
        }
    };
    
    exports.RQLogin = function(params) {
        var url = endpoint + "Auth/Login";

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    var loginResult = jsonResult.RQueryResult[0];

                    if (
                        loginResult.RQueryAuthToken !== undefined
                    &&  loginResult.IsAuthenticated !== undefined
                    &&  loginResult.IsAuthenticated
                    ) {
                        setAPIKey(loginResult.RQueryAPIKey);
                        setAuthToken(loginResult.RQueryAuthToken);
                    }
                    
                    resultHandler(
                         "Auth"
                        ,"Login"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Auth"
                        ,"Login"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    params.RQueryAPIKey
                }
            }
        );
    };
    
    exports.RQLogout = function(params) {
        var url = endpoint + "Auth/Logout";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    setAuthToken("");
                    
                    resultHandler(
                         "Auth"
                        ,"Logout"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    setAuthToken("");
                    
                    errorHandler(
                         "Auth"
                        ,"Logout"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };
    
    exports.RQSession = function(params) {
        var url = endpoint + "Auth/Session";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Auth"
                        ,"Session"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Auth"
                        ,"Session"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.RQConfig = function(params) {
        var url = endpoint + "Auth/Config";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Auth"
                        ,"Config"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Auth"
                        ,"Config"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.ExtensionsTranslateDescription = function(params) {
        var url = endpoint + "Extensions/TranslateDescription";

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeoutLong
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Extensions"
                        ,"TranslateDescription"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Extensions"
                        ,"TranslateDescription"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.ExtensionsMakeGroupBooking = function(params) {
        var url = endpoint + "Extensions/MakeGroupBooking";

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeoutLong
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Extensions"
                        ,"MakeGroupBooking"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Extensions"
                        ,"MakeGroupBooking"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.ExtensionsCancelBooking = function(params) {
        var url = endpoint + "Extensions/CancelBooking";

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeoutLong
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Extensions"
                        ,"CancelBooking"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Extensions"
                        ,"CancelBooking"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.ExtensionsUploadHotelPhoto = function (
         filePickerName
        ,hotelID
        ,callback
    ) {
        var url         = endpoint + "Extensions/UploadHotelPhoto";
        var resultLocal = { };

        resultLocal.FileID            = 0;
        resultLocal.FileLength        = 0;
        resultLocal.FileName          = "";
        resultLocal.FileUploadedOK    = false;
        resultLocal.FileUploadErrorNo = 0;
        resultLocal.FileUploadError   = "";

        var filepicker = document.getElementById(filePickerName);

        if (!filepicker) {
            resultLocal.FileUploadErrorNo = 10;
            resultLocal.FileUploadError   = "NO_PICKER_FOUND";

            return callback([resultLocal]);
        }

        if (filepicker.files.length == 0) {
            resultLocal.FileUploadErrorNo = 11;
            resultLocal.FileUploadError   = "NO_FILE_SELECTED";

            return callback([resultLocal]);
        }

        var file = filepicker.files[0];
        var xhr  = new XMLHttpRequest();

        if (file.size > 20971520) { // 20 MB file size cap
            resultLocal.FileUploadErrorNo = 12;
            resultLocal.FileUploadError   = "FILE_TOO_LARGE";

            return callback([resultLocal]);
        }

        xhr.open(
             'POST'
            ,url
            ,true
        );

        xhr.setRequestHeader('RQueryAPIKey'    ,getAPIKey());
        xhr.setRequestHeader('RQueryAuthToken' ,getAuthToken());
        xhr.setRequestHeader('Filename'        ,encodeURIComponent(file.name));
        xhr.setRequestHeader('HotelID'         ,hotelID);

        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    filepicker.value = '';

                    return callback(JSON.parse(xhr.responseText));
                } else {
                    var resultErr = { };

                    resultErr.FileID            = 0;
                    resultErr.FileLength        = 0;
                    resultErr.FileName          = "";
                    resultErr.FileUploadedOK    = false;
                    resultErr.FileUploadErrorNo = 13;
                    resultErr.FileUploadError   = "REMOTE_ERROR";

                    return callback([resultErr]);
                }
            }
        };

        return xhr.send(file);
    };

    exports.ExtensionsUploadUserPhoto = function (
         filePickerName
        ,callback
    ) {
        var url         = endpoint + "Extensions/UploadUserPhoto";
        var resultLocal = { };

        resultLocal.FileID            = 0;
        resultLocal.FileLength        = 0;
        resultLocal.FileName          = "";
        resultLocal.FileUploadedOK    = false;
        resultLocal.FileUploadErrorNo = 0;
        resultLocal.FileUploadError   = "";

        var filepicker = document.getElementById(filePickerName);

        if (!filepicker) {
            resultLocal.FileUploadErrorNo = 10;
            resultLocal.FileUploadError   = "NO_PICKER_FOUND";

            return callback([resultLocal]);
        }

        if (filepicker.files.length == 0) {
            resultLocal.FileUploadErrorNo = 11;
            resultLocal.FileUploadError   = "NO_FILE_SELECTED";

            return callback([resultLocal]);
        }

        var file = filepicker.files[0];
        var xhr  = new XMLHttpRequest();

        if (file.size > 20971520) { // 20 MB file size cap
            resultLocal.FileUploadErrorNo = 12;
            resultLocal.FileUploadError   = "FILE_TOO_LARGE";

            return callback([resultLocal]);
        }

        xhr.open(
             'POST'
            ,url
            ,true
        );

        xhr.setRequestHeader('RQueryAPIKey'    ,getAPIKey());
        xhr.setRequestHeader('RQueryAuthToken' ,getAuthToken());
        xhr.setRequestHeader('Filename'        ,encodeURIComponent(file.name));

        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    filepicker.value = '';

                    return callback(JSON.parse(xhr.responseText));
                } else {
                    var resultErr = { };

                    resultErr.FileID            = 0;
                    resultErr.FileLength        = 0;
                    resultErr.FileName          = "";
                    resultErr.FileUploadedOK    = false;
                    resultErr.FileUploadErrorNo = 13;
                    resultErr.FileUploadError   = "REMOTE_ERROR";

                    return callback([resultErr]);
                }
            }
        };

        return xhr.send(file);
    };

    exports.ExtensionsUploadUserPhotoDirect = function (
         file
        ,callback
    ) {
        var url         = endpoint + "Extensions/UploadUserPhoto";
        var resultLocal = { };

        resultLocal.FileID            = 0;
        resultLocal.FileLength        = 0;
        resultLocal.FileName          = "";
        resultLocal.FileUploadedOK    = false;
        resultLocal.FileUploadErrorNo = 0;
        resultLocal.FileUploadError   = "";

        var xhr  = new XMLHttpRequest();

        if (file.size > 20971520) { // 20 MB file size cap
            resultLocal.FileUploadErrorNo = 12;
            resultLocal.FileUploadError   = "FILE_TOO_LARGE";

            return callback([resultLocal]);
        }

        xhr.open(
             'POST'
            ,url
            ,true
        );

        xhr.setRequestHeader('RQueryAPIKey'    ,getAPIKey());
        xhr.setRequestHeader('RQueryAuthToken' ,getAuthToken());
        xhr.setRequestHeader('Filename'        ,encodeURIComponent(file.name));

        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    return callback(JSON.parse(xhr.responseText));
                } else {
                    var resultErr = { };

                    resultErr.FileID            = 0;
                    resultErr.FileLength        = 0;
                    resultErr.FileName          = "";
                    resultErr.FileUploadedOK    = false;
                    resultErr.FileUploadErrorNo = 13;
                    resultErr.FileUploadError   = "REMOTE_ERROR";

                    return callback([resultErr]);
                }
            }
        };

        return xhr.send(file);
    };

    exports.ExtensionsUploadHotelMap = function (
         filePickerName
        ,hotelID
        ,callback
    ) {
        var url         = endpoint + "Extensions/UploadHotelMap";
        var resultLocal = { };

        resultLocal.FileID            = 0;
        resultLocal.FileLength        = 0;
        resultLocal.FileName          = "";
        resultLocal.FileUploadedOK    = false;
        resultLocal.FileUploadErrorNo = 0;
        resultLocal.FileUploadError   = "";

        var filepicker = document.getElementById(filePickerName);

        if (!filepicker) {
            resultLocal.FileUploadErrorNo = 10;
            resultLocal.FileUploadError   = "NO_PICKER_FOUND";

            return callback([resultLocal]);
        }

        if (filepicker.files.length == 0) {
            resultLocal.FileUploadErrorNo = 11;
            resultLocal.FileUploadError   = "NO_FILE_SELECTED";

            return callback([resultLocal]);
        }

        var file = filepicker.files[0];
        var xhr  = new XMLHttpRequest();

        if (file.size > 20971520) { // 20 MB file size cap
            resultLocal.FileUploadErrorNo = 12;
            resultLocal.FileUploadError   = "FILE_TOO_LARGE";

            return callback([resultLocal]);
        }

        xhr.open(
             'POST'
            ,url
            ,true
        );

        xhr.setRequestHeader('RQueryAPIKey'    ,getAPIKey());
        xhr.setRequestHeader('RQueryAuthToken' ,getAuthToken());
        xhr.setRequestHeader('Filename'        ,encodeURIComponent(file.name));
        xhr.setRequestHeader('HotelID'         ,hotelID);

        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    filepicker.value = '';

                    return callback(JSON.parse(xhr.responseText));
                } else {
                    var resultErr = { };

                    resultErr.FileID            = 0;
                    resultErr.FileLength        = 0;
                    resultErr.FileName          = "";
                    resultErr.FileUploadedOK    = false;
                    resultErr.FileUploadErrorNo = 13;
                    resultErr.FileUploadError   = "REMOTE_ERROR";

                    return callback([resultErr]);
                }
            }
        };

        return xhr.send(file);
    };

    exports.ExtensionsUploadHotelDoc = function (
         filePickerName
        ,hotelID
        ,callback
    ) {
        var url         = endpoint + "Extensions/UploadHotelDoc";
        var resultLocal = { };

        resultLocal.FileID            = 0;
        resultLocal.FileLength        = 0;
        resultLocal.FileName          = "";
        resultLocal.FileUploadedOK    = false;
        resultLocal.FileUploadErrorNo = 0;
        resultLocal.FileUploadError   = "";

        var filepicker = document.getElementById(filePickerName);

        if (!filepicker) {
            resultLocal.FileUploadErrorNo = 10;
            resultLocal.FileUploadError   = "NO_PICKER_FOUND";

            return callback([resultLocal]);
        }

        if (filepicker.files.length == 0) {
            resultLocal.FileUploadErrorNo = 11;
            resultLocal.FileUploadError   = "NO_FILE_SELECTED";

            return callback([resultLocal]);
        }

        var file = filepicker.files[0];
        var xhr  = new XMLHttpRequest();

        if (file.size > 20971520) { // 20 MB file size cap
            resultLocal.FileUploadErrorNo = 12;
            resultLocal.FileUploadError   = "FILE_TOO_LARGE";

            return callback([resultLocal]);
        }

        xhr.open(
             'POST'
            ,url
            ,true
        );

        xhr.setRequestHeader('RQueryAPIKey'    ,getAPIKey());
        xhr.setRequestHeader('RQueryAuthToken' ,getAuthToken());
        xhr.setRequestHeader('Filename'        ,encodeURIComponent(file.name));
        xhr.setRequestHeader('HotelID'         ,hotelID);

        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    filepicker.value = '';

                    return callback(JSON.parse(xhr.responseText));
                } else {
                    var resultErr = { };

                    resultErr.FileID            = 0;
                    resultErr.FileLength        = 0;
                    resultErr.FileName          = "";
                    resultErr.FileUploadedOK    = false;
                    resultErr.FileUploadErrorNo = 13;
                    resultErr.FileUploadError   = "REMOTE_ERROR";

                    return callback([resultErr]);
                }
            }
        };

        return xhr.send(file);
    };


    exports.ExtensionsRetrieveProfilePicture = function (params) {
        var url = endpoint + "Extensions/RetrieveProfilePicture";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Extensions"
                        ,"RetrieveProfilePicture"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Extensions"
                        ,"RetrieveProfilePicture"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.ExtensionsMakePayment = function(params) {
        var url = endpoint + "Extensions/MakePayment";

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/x-www-form-urlencoded"
                ,data:        params
                ,timeout:     rqTimeoutLong
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Extensions"
                        ,"MakePayment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Extensions"
                        ,"MakePayment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAcceptAvUpdateDaysViaGrid = function(params) {
        var url = endpoint + "Pms/AcceptAvUpdateDaysViaGrid";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AcceptAvUpdateDaysViaGrid"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AcceptAvUpdateDaysViaGrid"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAcceptAvUpdateDaysViaManualEntry = function(params) {
        var url = endpoint + "Pms/AcceptAvUpdateDaysViaManualEntry";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AcceptAvUpdateDaysViaManualEntry"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AcceptAvUpdateDaysViaManualEntry"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAcceptRateUpdateDaysViaManualEntry = function(params) {
        var url = endpoint + "Pms/AcceptRateUpdateDaysViaManualEntry";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AcceptRateUpdateDaysViaManualEntry"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AcceptRateUpdateDaysViaManualEntry"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAcceptRateUpdateDaysViaManualEntryFull = function(params) {
        var url = endpoint + "Pms/AcceptRateUpdateDaysViaManualEntryFull";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AcceptRateUpdateDaysViaManualEntryFull"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AcceptRateUpdateDaysViaManualEntryFull"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAcceptRateUpdateWeekDaysViaManualEntry = function(params) {
        var url = endpoint + "Pms/AcceptRateUpdateWeekDaysViaManualEntry";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AcceptRateUpdateWeekDaysViaManualEntry"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AcceptRateUpdateWeekDaysViaManualEntry"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAcceptRateUpdateWeekDaysViaManualEntryFull = function(params) {
        var url = endpoint + "Pms/AcceptRateUpdateWeekDaysViaManualEntryFull";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AcceptRateUpdateWeekDaysViaManualEntryFull"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AcceptRateUpdateWeekDaysViaManualEntryFull"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAdaptLocalAllotment = function(params) {
        var url = endpoint + "Pms/AdaptLocalAllotment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AdaptLocalAllotment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AdaptLocalAllotment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAdaptLocalStopSell = function(params) {
        var url = endpoint + "Pms/AdaptLocalStopSell";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AdaptLocalStopSell"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AdaptLocalStopSell"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAlertModificationHavingLocalPMSEdit = function(params) {
        var url = endpoint + "Pms/AlertModificationHavingLocalPMSEdit";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AlertModificationHavingLocalPMSEdit"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AlertModificationHavingLocalPMSEdit"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAlterDailyPriceInfo = function(params) {
        var url = endpoint + "Pms/AlterDailyPriceInfo";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AlterDailyPriceInfo"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AlterDailyPriceInfo"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAlterRoomReservationStatus = function(params) {
        var url = endpoint + "Pms/AlterRoomReservationStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AlterRoomReservationStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AlterRoomReservationStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAlterRoomTypeStopSell = function(params) {
        var url = endpoint + "Pms/AlterRoomTypeStopSell";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AlterRoomTypeStopSell"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AlterRoomTypeStopSell"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAppendToReservationNotes = function(params) {
        var url = endpoint + "Pms/AppendToReservationNotes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AppendToReservationNotes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AppendToReservationNotes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAssignGuestToReservation = function(params) {
        var url = endpoint + "Pms/AssignGuestToReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AssignGuestToReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AssignGuestToReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAssignGuestToRoomByRoomReservation = function(params) {
        var url = endpoint + "Pms/AssignGuestToRoomByRoomReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AssignGuestToRoomByRoomReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AssignGuestToRoomByRoomReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAssignPartnerToChannel = function(params) {
        var url = endpoint + "Pms/AssignPartnerToChannel";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AssignPartnerToChannel"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AssignPartnerToChannel"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAssignReservationToOwningGuest = function(params) {
        var url = endpoint + "Pms/AssignReservationToOwningGuest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AssignReservationToOwningGuest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AssignReservationToOwningGuest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAssignRoomReservationToOwningGuest = function(params) {
        var url = endpoint + "Pms/AssignRoomReservationToOwningGuest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AssignRoomReservationToOwningGuest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AssignRoomReservationToOwningGuest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAttachRoomReservationSegment = function(params) {
        var url = endpoint + "Pms/AttachRoomReservationSegment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AttachRoomReservationSegment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AttachRoomReservationSegment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsAuthenticateAdminPassword = function(params) {
        var url = endpoint + "Pms/AuthenticateAdminPassword";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"AuthenticateAdminPassword"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"AuthenticateAdminPassword"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsBackupDataBase = function(params) {
        var url = endpoint + "Pms/BackupDataBase";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"BackupDataBase"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"BackupDataBase"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsBlockOutOfOrderRoom = function(params) {
        var url = endpoint + "Pms/BlockOutOfOrderRoom";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"BlockOutOfOrderRoom"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"BlockOutOfOrderRoom"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCancelReservation = function(params) {
        var url = endpoint + "Pms/CancelReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CancelReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CancelReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCancelRoomReservation = function(params) {
        var url = endpoint + "Pms/CancelRoomReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CancelRoomReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CancelRoomReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCheckAvailability = function(params) {
        var url = endpoint + "Pms/CheckAvailability";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CheckAvailability"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CheckAvailability"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCheckAvailabilityMove = function(params) {
        var url = endpoint + "Pms/CheckAvailabilityMove";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CheckAvailabilityMove"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CheckAvailabilityMove"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCheckAvailableRooms = function(params) {
        var url = endpoint + "Pms/CheckAvailableRooms";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CheckAvailableRooms"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CheckAvailableRooms"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCheckInRoomReservation = function(params) {
        var url = endpoint + "Pms/CheckInRoomReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CheckInRoomReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CheckInRoomReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCheckOfferTypeCacheDataStatus = function(params) {
        var url = endpoint + "Pms/CheckOfferTypeCacheDataStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CheckOfferTypeCacheDataStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CheckOfferTypeCacheDataStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCheckOutRoomReservation = function(params) {
        var url = endpoint + "Pms/CheckOutRoomReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CheckOutRoomReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CheckOutRoomReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCheckResConstraints = function(params) {
        var url = endpoint + "Pms/CheckResConstraints";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CheckResConstraints"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CheckResConstraints"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCheckRoomAvailability = function(params) {
        var url = endpoint + "Pms/CheckRoomAvailability";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CheckRoomAvailability"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CheckRoomAvailability"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCheckRoomTypeCacheDataStatus = function(params) {
        var url = endpoint + "Pms/CheckRoomTypeCacheDataStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CheckRoomTypeCacheDataStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CheckRoomTypeCacheDataStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsConfirmOTAReservationRetrieval = function(params) {
        var url = endpoint + "Pms/ConfirmOTAReservationRetrieval";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ConfirmOTAReservationRetrieval"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ConfirmOTAReservationRetrieval"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsConfirmOTAReservationRetrievalWithToken = function(params) {
        var url = endpoint + "Pms/ConfirmOTAReservationRetrievalWithToken";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ConfirmOTAReservationRetrievalWithToken"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ConfirmOTAReservationRetrievalWithToken"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsConfirmReservation = function(params) {
        var url = endpoint + "Pms/ConfirmReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ConfirmReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ConfirmReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCountPendingChannelActions = function(params) {
        var url = endpoint + "Pms/CountPendingChannelActions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CountPendingChannelActions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CountPendingChannelActions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCreateAccount = function(params) {
        var url = endpoint + "Pms/CreateAccount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CreateAccount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CreateAccount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCreateOrChangeGuiMessage = function(params) {
        var url = endpoint + "Pms/CreateOrChangeGuiMessage";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CreateOrChangeGuiMessage"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CreateOrChangeGuiMessage"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCreateOrEditCPolicyByOfferType = function(params) {
        var url = endpoint + "Pms/CreateOrEditCPolicyByOfferType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CreateOrEditCPolicyByOfferType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CreateOrEditCPolicyByOfferType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCreateOrGetFormElementID = function(params) {
        var url = endpoint + "Pms/CreateOrGetFormElementID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CreateOrGetFormElementID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CreateOrGetFormElementID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsCreateOrGetFormID = function(params) {
        var url = endpoint + "Pms/CreateOrGetFormID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"CreateOrGetFormID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"CreateOrGetFormID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteAddons = function(params) {
        var url = endpoint + "Pms/DeleteAddons";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteAddons"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteAddons"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteExhibitionPeriod = function(params) {
        var url = endpoint + "Pms/DeleteExhibitionPeriod";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteExhibitionPeriod"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteExhibitionPeriod"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteOfferType = function(params) {
        var url = endpoint + "Pms/DeleteOfferType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteOfferType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteOfferType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeletePartner = function(params) {
        var url = endpoint + "Pms/DeletePartner";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeletePartner"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeletePartner"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteRackRatePeriod = function(params) {
        var url = endpoint + "Pms/DeleteRackRatePeriod";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteRackRatePeriod"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteRackRatePeriod"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteReservationInCreation = function(params) {
        var url = endpoint + "Pms/DeleteReservationInCreation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteReservationInCreation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteReservationInCreation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteRoom = function(params) {
        var url = endpoint + "Pms/DeleteRoom";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteRoom"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteRoom"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteRoomPeriodNote = function(params) {
        var url = endpoint + "Pms/DeleteRoomPeriodNote";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteRoomPeriodNote"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteRoomPeriodNote"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteRoomReservation = function(params) {
        var url = endpoint + "Pms/DeleteRoomReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteRoomReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteRoomReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteRoomType = function(params) {
        var url = endpoint + "Pms/DeleteRoomType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteRoomType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteRoomType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteRoomTypeName = function(params) {
        var url = endpoint + "Pms/DeleteRoomTypeName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteRoomTypeName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteRoomTypeName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteSMTPServer = function(params) {
        var url = endpoint + "Pms/DeleteSMTPServer";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteSMTPServer"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteSMTPServer"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteTemplate = function(params) {
        var url = endpoint + "Pms/DeleteTemplate";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteTemplate"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteTemplate"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDeleteUser = function(params) {
        var url = endpoint + "Pms/DeleteUser";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DeleteUser"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DeleteUser"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDetachRoomReservationSegment = function(params) {
        var url = endpoint + "Pms/DetachRoomReservationSegment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DetachRoomReservationSegment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DetachRoomReservationSegment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsDowngradeRoomResWithExpiredHoldUntil = function(params) {
        var url = endpoint + "Pms/DowngradeRoomResWithExpiredHoldUntil";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"DowngradeRoomResWithExpiredHoldUntil"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"DowngradeRoomResWithExpiredHoldUntil"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditCustomer = function(params) {
        var url = endpoint + "Pms/EditCustomer";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditCustomer"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditCustomer"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditCustomerPassword = function(params) {
        var url = endpoint + "Pms/EditCustomerPassword";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditCustomerPassword"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditCustomerPassword"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditExhibitionPeriod = function(params) {
        var url = endpoint + "Pms/EditExhibitionPeriod";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditExhibitionPeriod"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditExhibitionPeriod"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditExternalReservationID = function(params) {
        var url = endpoint + "Pms/EditExternalReservationID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditExternalReservationID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditExternalReservationID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditGuest = function(params) {
        var url = endpoint + "Pms/EditGuest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditGuest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditGuest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditHotelDetails = function(params) {
        var url = endpoint + "Pms/EditHotelDetails";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditHotelDetails"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditHotelDetails"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditHotelFinancialDetails = function(params) {
        var url = endpoint + "Pms/EditHotelFinancialDetails";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditHotelFinancialDetails"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditHotelFinancialDetails"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditHotelPassword = function(params) {
        var url = endpoint + "Pms/EditHotelPassword";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditHotelPassword"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditHotelPassword"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditMLViewText = function(params) {
        var url = endpoint + "Pms/EditMLViewText";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditMLViewText"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditMLViewText"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditNumPersonsStaying = function(params) {
        var url = endpoint + "Pms/EditNumPersonsStaying";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditNumPersonsStaying"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditNumPersonsStaying"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditOfferType = function(params) {
        var url = endpoint + "Pms/EditOfferType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditOfferType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditOfferType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditOfferTypeAsDiscount = function(params) {
        var url = endpoint + "Pms/EditOfferTypeAsDiscount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditOfferTypeAsDiscount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditOfferTypeAsDiscount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditOfferTypeName = function(params) {
        var url = endpoint + "Pms/EditOfferTypeName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditOfferTypeName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditOfferTypeName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditPartner = function(params) {
        var url = endpoint + "Pms/EditPartner";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditPartner"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditPartner"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditPriorityNotes = function(params) {
        var url = endpoint + "Pms/EditPriorityNotes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditPriorityNotes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditPriorityNotes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditRackRate = function(params) {
        var url = endpoint + "Pms/EditRackRate";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditRackRate"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditRackRate"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditRackRateFilterAllotment = function(params) {
        var url = endpoint + "Pms/EditRackRateFilterAllotment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditRackRateFilterAllotment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditRackRateFilterAllotment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditRackRatePeriod = function(params) {
        var url = endpoint + "Pms/EditRackRatePeriod";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditRackRatePeriod"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditRackRatePeriod"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditReservationDetails = function(params) {
        var url = endpoint + "Pms/EditReservationDetails";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditReservationDetails"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditReservationDetails"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditReservationPartner = function(params) {
        var url = endpoint + "Pms/EditReservationPartner";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditReservationPartner"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditReservationPartner"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditRoom = function(params) {
        var url = endpoint + "Pms/EditRoom";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditRoom"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditRoom"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditRoomPeriodNote = function(params) {
        var url = endpoint + "Pms/EditRoomPeriodNote";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditRoomPeriodNote"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditRoomPeriodNote"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditRoomReservationParams = function(params) {
        var url = endpoint + "Pms/EditRoomReservationParams";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditRoomReservationParams"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditRoomReservationParams"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditRoomType = function(params) {
        var url = endpoint + "Pms/EditRoomType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditRoomType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditRoomType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditRoomTypeName = function(params) {
        var url = endpoint + "Pms/EditRoomTypeName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditRoomTypeName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditRoomTypeName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditRoomTypeNameAndParams = function(params) {
        var url = endpoint + "Pms/EditRoomTypeNameAndParams";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditRoomTypeNameAndParams"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditRoomTypeNameAndParams"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditSMTPServer = function(params) {
        var url = endpoint + "Pms/EditSMTPServer";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditSMTPServer"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditSMTPServer"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditTemplate = function(params) {
        var url = endpoint + "Pms/EditTemplate";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditTemplate"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditTemplate"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditThirdPartyRoomReservationParams = function(params) {
        var url = endpoint + "Pms/EditThirdPartyRoomReservationParams";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditThirdPartyRoomReservationParams"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditThirdPartyRoomReservationParams"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsEditUser = function(params) {
        var url = endpoint + "Pms/EditUser";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"EditUser"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"EditUser"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsExistBrokenRes = function(params) {
        var url = endpoint + "Pms/ExistBrokenRes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ExistBrokenRes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ExistBrokenRes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsExistNewNotifications = function(params) {
        var url = endpoint + "Pms/ExistNewNotifications";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ExistNewNotifications"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ExistNewNotifications"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsExistUnverifiedNotifications = function(params) {
        var url = endpoint + "Pms/ExistUnverifiedNotifications";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ExistUnverifiedNotifications"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ExistUnverifiedNotifications"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsFinaliseFormTextExtractionPass = function(params) {
        var url = endpoint + "Pms/FinaliseFormTextExtractionPass";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"FinaliseFormTextExtractionPass"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"FinaliseFormTextExtractionPass"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetActiveBookingDotComReservations = function(params) {
        var url = endpoint + "Pms/GetActiveBookingDotComReservations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetActiveBookingDotComReservations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetActiveBookingDotComReservations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetActiveMonitoredHotels = function(params) {
        var url = endpoint + "Pms/GetActiveMonitoredHotels";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetActiveMonitoredHotels"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetActiveMonitoredHotels"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetActiveRemotePartners = function(params) {
        var url = endpoint + "Pms/GetActiveRemotePartners";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetActiveRemotePartners"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetActiveRemotePartners"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetAgeBasedOccupancy = function(params) {
        var url = endpoint + "Pms/GetAgeBasedOccupancy";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetAgeBasedOccupancy"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetAgeBasedOccupancy"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetAllOfferTypeBucketData = function(params) {
        var url = endpoint + "Pms/GetAllOfferTypeBucketData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetAllOfferTypeBucketData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetAllOfferTypeBucketData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetAssignedPartnersByOfferType = function(params) {
        var url = endpoint + "Pms/GetAssignedPartnersByOfferType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetAssignedPartnersByOfferType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetAssignedPartnersByOfferType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetAvailabilityPeriod = function(params) {
        var url = endpoint + "Pms/GetAvailabilityPeriod";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetAvailabilityPeriod"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetAvailabilityPeriod"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetAvailableRoomEditTotals = function(params) {
        var url = endpoint + "Pms/GetAvailableRoomEditTotals";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetAvailableRoomEditTotals"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetAvailableRoomEditTotals"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetAvailableRoomTotals = function(params) {
        var url = endpoint + "Pms/GetAvailableRoomTotals";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetAvailableRoomTotals"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetAvailableRoomTotals"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetBookingDotComDeviceCookie = function(params) {
        var url = endpoint + "Pms/GetBookingDotComDeviceCookie";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetBookingDotComDeviceCookie"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetBookingDotComDeviceCookie"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCancellationFee = function(params) {
        var url = endpoint + "Pms/GetCancellationFee";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCancellationFee"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCancellationFee"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCCTypes = function(params) {
        var url = endpoint + "Pms/GetCCTypes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCCTypes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCCTypes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetChannelBucketNavigationData = function(params) {
        var url = endpoint + "Pms/GetChannelBucketNavigationData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetChannelBucketNavigationData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetChannelBucketNavigationData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCountries = function(params) {
        var url = endpoint + "Pms/GetCountries";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCountries"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCountries"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCountryIDByCode = function(params) {
        var url = endpoint + "Pms/GetCountryIDByCode";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCountryIDByCode"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCountryIDByCode"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCountryIDByEnName = function(params) {
        var url = endpoint + "Pms/GetCountryIDByEnName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCountryIDByEnName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCountryIDByEnName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCountryIDByISOCode = function(params) {
        var url = endpoint + "Pms/GetCountryIDByISOCode";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCountryIDByISOCode"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCountryIDByISOCode"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCountryParamsFromPath = function(params) {
        var url = endpoint + "Pms/GetCountryParamsFromPath";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCountryParamsFromPath"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCountryParamsFromPath"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCPolicyByOfferTypeID = function(params) {
        var url = endpoint + "Pms/GetCPolicyByOfferTypeID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCPolicyByOfferTypeID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCPolicyByOfferTypeID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCTMAccountSettings = function(params) {
        var url = endpoint + "Pms/GetCTMAccountSettings";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCTMAccountSettings"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCTMAccountSettings"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCurrentCacheWindow = function(params) {
        var url = endpoint + "Pms/GetCurrentCacheWindow";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCurrentCacheWindow"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCurrentCacheWindow"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCurrentShift = function(params) {
        var url = endpoint + "Pms/GetCurrentShift";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCurrentShift"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCurrentShift"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCurrentShiftStart = function(params) {
        var url = endpoint + "Pms/GetCurrentShiftStart";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCurrentShiftStart"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCurrentShiftStart"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomer = function(params) {
        var url = endpoint + "Pms/GetCustomer";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomer"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomer"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomerBookingHotels = function(params) {
        var url = endpoint + "Pms/GetCustomerBookingHotels";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomerBookingHotels"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomerBookingHotels"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomerBookings = function(params) {
        var url = endpoint + "Pms/GetCustomerBookings";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomerBookings"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomerBookings"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomerIDByEmail = function(params) {
        var url = endpoint + "Pms/GetCustomerIDByEmail";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomerIDByEmail"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomerIDByEmail"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomerOffersByArrDep = function(params) {
        var url = endpoint + "Pms/GetCustomerOffersByArrDep";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomerOffersByArrDep"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomerOffersByArrDep"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomerOffersByArrDepBoundsCoordsFullWithDiscount = function(params) {
        var url = endpoint + "Pms/GetCustomerOffersByArrDepBoundsCoordsFullWithDiscount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomerOffersByArrDepBoundsCoordsFullWithDiscount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomerOffersByArrDepBoundsCoordsFullWithDiscount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomerOffersByArrDepCoordsFullWithDiscount = function(params) {
        var url = endpoint + "Pms/GetCustomerOffersByArrDepCoordsFullWithDiscount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomerOffersByArrDepCoordsFullWithDiscount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomerOffersByArrDepCoordsFullWithDiscount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomerOffersByArrDepWithDiscountInfo = function(params) {
        var url = endpoint + "Pms/GetCustomerOffersByArrDepWithDiscountInfo";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomerOffersByArrDepWithDiscountInfo"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomerOffersByArrDepWithDiscountInfo"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomerOffersByLocationArrDepFullWithDiscount = function(params) {
        var url = endpoint + "Pms/GetCustomerOffersByLocationArrDepFullWithDiscount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomerOffersByLocationArrDepFullWithDiscount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomerOffersByLocationArrDepFullWithDiscount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomerOffersBySearchLocationArrDepCoordsFullWithDiscount = function(params) {
        var url = endpoint + "Pms/GetCustomerOffersBySearchLocationArrDepCoordsFullWithDiscount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomerOffersBySearchLocationArrDepCoordsFullWithDiscount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomerOffersBySearchLocationArrDepCoordsFullWithDiscount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomerOffersBySearchLocationArrDepFullWithDiscount = function(params) {
        var url = endpoint + "Pms/GetCustomerOffersBySearchLocationArrDepFullWithDiscount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomerOffersBySearchLocationArrDepFullWithDiscount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomerOffersBySearchLocationArrDepFullWithDiscount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetCustomerOffersBySearchLocationArrDepFullWithDiscountAndPageHint = function(params) {
        var url = endpoint + "Pms/GetCustomerOffersBySearchLocationArrDepFullWithDiscountAndPageHint";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetCustomerOffersBySearchLocationArrDepFullWithDiscountAndPageHint"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetCustomerOffersBySearchLocationArrDepFullWithDiscountAndPageHint"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetDaysWithFineTunedRateData = function(params) {
        var url = endpoint + "Pms/GetDaysWithFineTunedRateData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetDaysWithFineTunedRateData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetDaysWithFineTunedRateData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetEarlyBirdOfferType = function(params) {
        var url = endpoint + "Pms/GetEarlyBirdOfferType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetEarlyBirdOfferType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetEarlyBirdOfferType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetEasyNonRefOfferType = function(params) {
        var url = endpoint + "Pms/GetEasyNonRefOfferType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetEasyNonRefOfferType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetEasyNonRefOfferType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetExclusiveRateChannelData = function(params) {
        var url = endpoint + "Pms/GetExclusiveRateChannelData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetExclusiveRateChannelData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetExclusiveRateChannelData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetExclusiveRateDiscountFilters = function(params) {
        var url = endpoint + "Pms/GetExclusiveRateDiscountFilters";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetExclusiveRateDiscountFilters"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetExclusiveRateDiscountFilters"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetExclusiveRatePeriods = function(params) {
        var url = endpoint + "Pms/GetExclusiveRatePeriods";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetExclusiveRatePeriods"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetExclusiveRatePeriods"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetExhibitionDayWindow = function(params) {
        var url = endpoint + "Pms/GetExhibitionDayWindow";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetExhibitionDayWindow"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetExhibitionDayWindow"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetExhibitionPeriods = function(params) {
        var url = endpoint + "Pms/GetExhibitionPeriods";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetExhibitionPeriods"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetExhibitionPeriods"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetFirstBusinessDay = function(params) {
        var url = endpoint + "Pms/GetFirstBusinessDay";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetFirstBusinessDay"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetFirstBusinessDay"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetGuest = function(params) {
        var url = endpoint + "Pms/GetGuest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetGuest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetGuest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetGuestByReservation = function(params) {
        var url = endpoint + "Pms/GetGuestByReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetGuestByReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetGuestByReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetGuestIdentificationTypes = function(params) {
        var url = endpoint + "Pms/GetGuestIdentificationTypes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetGuestIdentificationTypes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetGuestIdentificationTypes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetGuestTitles = function(params) {
        var url = endpoint + "Pms/GetGuestTitles";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetGuestTitles"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetGuestTitles"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetHotel = function(params) {
        var url = endpoint + "Pms/GetHotel";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetHotel"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetHotel"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetHotelBreakfastData = function(params) {
        var url = endpoint + "Pms/GetHotelBreakfastData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetHotelBreakfastData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetHotelBreakfastData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetHotelBreakfastDefault = function(params) {
        var url = endpoint + "Pms/GetHotelBreakfastDefault";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetHotelBreakfastDefault"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetHotelBreakfastDefault"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetHotelModules = function(params) {
        var url = endpoint + "Pms/GetHotelModules";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetHotelModules"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetHotelModules"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetHotelOccupancyAndBreakfastTotals = function(params) {
        var url = endpoint + "Pms/GetHotelOccupancyAndBreakfastTotals";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetHotelOccupancyAndBreakfastTotals"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetHotelOccupancyAndBreakfastTotals"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetHotelOccupancyData = function(params) {
        var url = endpoint + "Pms/GetHotelOccupancyData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetHotelOccupancyData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetHotelOccupancyData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetHotelsAndActiveRemotePartners = function(params) {
        var url = endpoint + "Pms/GetHotelsAndActiveRemotePartners";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetHotelsAndActiveRemotePartners"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetHotelsAndActiveRemotePartners"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetHotelsNeedingConfigCacheSync = function(params) {
        var url = endpoint + "Pms/GetHotelsNeedingConfigCacheSync";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetHotelsNeedingConfigCacheSync"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetHotelsNeedingConfigCacheSync"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetIntersectingRoomRates = function(params) {
        var url = endpoint + "Pms/GetIntersectingRoomRates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetIntersectingRoomRates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetIntersectingRoomRates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetJobs = function(params) {
        var url = endpoint + "Pms/GetJobs";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetJobs"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetJobs"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetLanguages = function(params) {
        var url = endpoint + "Pms/GetLanguages";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetLanguages"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetLanguages"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetLocalPartnerFromGatewayPartner = function(params) {
        var url = endpoint + "Pms/GetLocalPartnerFromGatewayPartner";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetLocalPartnerFromGatewayPartner"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetLocalPartnerFromGatewayPartner"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetLocationAndHotelParamsFromPath = function(params) {
        var url = endpoint + "Pms/GetLocationAndHotelParamsFromPath";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetLocationAndHotelParamsFromPath"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetLocationAndHotelParamsFromPath"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetLocationAndHotelParamsFromPathML = function(params) {
        var url = endpoint + "Pms/GetLocationAndHotelParamsFromPathML";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetLocationAndHotelParamsFromPathML"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetLocationAndHotelParamsFromPathML"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetLocationParamsFromPath = function(params) {
        var url = endpoint + "Pms/GetLocationParamsFromPath";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetLocationParamsFromPath"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetLocationParamsFromPath"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetLocationParamsFromPathML = function(params) {
        var url = endpoint + "Pms/GetLocationParamsFromPathML";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetLocationParamsFromPathML"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetLocationParamsFromPathML"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetMaxPersonsRateNames = function(params) {
        var url = endpoint + "Pms/GetMaxPersonsRateNames";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetMaxPersonsRateNames"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetMaxPersonsRateNames"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetMaxPersonsRateNamesByRoomType = function(params) {
        var url = endpoint + "Pms/GetMaxPersonsRateNamesByRoomType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetMaxPersonsRateNamesByRoomType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetMaxPersonsRateNamesByRoomType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetMessageByErrorCode = function(params) {
        var url = endpoint + "Pms/GetMessageByErrorCode";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetMessageByErrorCode"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetMessageByErrorCode"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetMixedRoomRateOfferDayInfoAll = function(params) {
        var url = endpoint + "Pms/GetMixedRoomRateOfferDayInfoAll";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetMixedRoomRateOfferDayInfoAll"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetMixedRoomRateOfferDayInfoAll"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetMixedRoomRateOfferInfo = function(params) {
        var url = endpoint + "Pms/GetMixedRoomRateOfferInfo";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetMixedRoomRateOfferInfo"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetMixedRoomRateOfferInfo"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetMixedRoomRateOfferInfoAll = function(params) {
        var url = endpoint + "Pms/GetMixedRoomRateOfferInfoAll";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetMixedRoomRateOfferInfoAll"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetMixedRoomRateOfferInfoAll"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetMixedRoomRateOfferTotal = function(params) {
        var url = endpoint + "Pms/GetMixedRoomRateOfferTotal";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetMixedRoomRateOfferTotal"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetMixedRoomRateOfferTotal"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetMixedRoomRateOfferTotalWithDiscount = function(params) {
        var url = endpoint + "Pms/GetMixedRoomRateOfferTotalWithDiscount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetMixedRoomRateOfferTotalWithDiscount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetMixedRoomRateOfferTotalWithDiscount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetMLViews = function(params) {
        var url = endpoint + "Pms/GetMLViews";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetMLViews"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetMLViews"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetMLViewTexts = function(params) {
        var url = endpoint + "Pms/GetMLViewTexts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetMLViewTexts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetMLViewTexts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetNotificationEvent = function(params) {
        var url = endpoint + "Pms/GetNotificationEvent";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetNotificationEvent"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetNotificationEvent"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetNotificationEvents = function(params) {
        var url = endpoint + "Pms/GetNotificationEvents";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetNotificationEvents"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetNotificationEvents"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOccupancyData = function(params) {
        var url = endpoint + "Pms/GetOccupancyData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOccupancyData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOccupancyData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOccupancyDataWindow = function(params) {
        var url = endpoint + "Pms/GetOccupancyDataWindow";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOccupancyDataWindow"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOccupancyDataWindow"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferType = function(params) {
        var url = endpoint + "Pms/GetOfferType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeAutoNames = function(params) {
        var url = endpoint + "Pms/GetOfferTypeAutoNames";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeAutoNames"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeAutoNames"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeIDByPartnerOfferTypeID = function(params) {
        var url = endpoint + "Pms/GetOfferTypeIDByPartnerOfferTypeID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeIDByPartnerOfferTypeID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeIDByPartnerOfferTypeID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeIDByPartnerOfferTypeName = function(params) {
        var url = endpoint + "Pms/GetOfferTypeIDByPartnerOfferTypeName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeIDByPartnerOfferTypeName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeIDByPartnerOfferTypeName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeListeners = function(params) {
        var url = endpoint + "Pms/GetOfferTypeListeners";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeListeners"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeListeners"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeMemberDiscountDays = function(params) {
        var url = endpoint + "Pms/GetOfferTypeMemberDiscountDays";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeMemberDiscountDays"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeMemberDiscountDays"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeMemberDiscounts = function(params) {
        var url = endpoint + "Pms/GetOfferTypeMemberDiscounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeMemberDiscounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeMemberDiscounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeMemberDiscountWindow = function(params) {
        var url = endpoint + "Pms/GetOfferTypeMemberDiscountWindow";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeMemberDiscountWindow"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeMemberDiscountWindow"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeName = function(params) {
        var url = endpoint + "Pms/GetOfferTypeName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeNamesAll = function(params) {
        var url = endpoint + "Pms/GetOfferTypeNamesAll";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeNamesAll"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeNamesAll"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeNavigationData = function(params) {
        var url = endpoint + "Pms/GetOfferTypeNavigationData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeNavigationData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeNavigationData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypePartners = function(params) {
        var url = endpoint + "Pms/GetOfferTypePartners";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypePartners"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypePartners"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypes = function(params) {
        var url = endpoint + "Pms/GetOfferTypes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypesByPartner = function(params) {
        var url = endpoint + "Pms/GetOfferTypesByPartner";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypesByPartner"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypesByPartner"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeSharedAllotmentGroups = function(params) {
        var url = endpoint + "Pms/GetOfferTypeSharedAllotmentGroups";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeSharedAllotmentGroups"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeSharedAllotmentGroups"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetOfferTypeSharedRateGroups = function(params) {
        var url = endpoint + "Pms/GetOfferTypeSharedRateGroups";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetOfferTypeSharedRateGroups"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetOfferTypeSharedRateGroups"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetPartner = function(params) {
        var url = endpoint + "Pms/GetPartner";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetPartner"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetPartner"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetPartnerOfferTypeID = function(params) {
        var url = endpoint + "Pms/GetPartnerOfferTypeID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetPartnerOfferTypeID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetPartnerOfferTypeID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetPartners = function(params) {
        var url = endpoint + "Pms/GetPartners";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetPartners"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetPartners"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetPartnersWithPendingChannelActions = function(params) {
        var url = endpoint + "Pms/GetPartnersWithPendingChannelActions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetPartnersWithPendingChannelActions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetPartnersWithPendingChannelActions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetPaymentSchemes = function(params) {
        var url = endpoint + "Pms/GetPaymentSchemes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetPaymentSchemes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetPaymentSchemes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetPaymentSchemesOTA = function(params) {
        var url = endpoint + "Pms/GetPaymentSchemesOTA";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetPaymentSchemesOTA"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetPaymentSchemesOTA"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetPendingChannelActions = function(params) {
        var url = endpoint + "Pms/GetPendingChannelActions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetPendingChannelActions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetPendingChannelActions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetPMSOverviewDataFull = function(params) {
        var url = endpoint + "Pms/GetPMSOverviewDataFull";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetPMSOverviewDataFull"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetPMSOverviewDataFull"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetPMSOverviewDataSlim = function(params) {
        var url = endpoint + "Pms/GetPMSOverviewDataSlim";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetPMSOverviewDataSlim"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetPMSOverviewDataSlim"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetPMSOverviewRateData = function(params) {
        var url = endpoint + "Pms/GetPMSOverviewRateData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetPMSOverviewRateData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetPMSOverviewRateData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetPrimarySMTPServer = function(params) {
        var url = endpoint + "Pms/GetPrimarySMTPServer";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetPrimarySMTPServer"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetPrimarySMTPServer"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetProjectedTurnover = function(params) {
        var url = endpoint + "Pms/GetProjectedTurnover";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetProjectedTurnover"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetProjectedTurnover"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetProjectedTurnoverByPartner = function(params) {
        var url = endpoint + "Pms/GetProjectedTurnoverByPartner";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetProjectedTurnoverByPartner"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetProjectedTurnoverByPartner"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetProjectedTurnoverTotals = function(params) {
        var url = endpoint + "Pms/GetProjectedTurnoverTotals";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetProjectedTurnoverTotals"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetProjectedTurnoverTotals"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRackRateChannelData = function(params) {
        var url = endpoint + "Pms/GetRackRateChannelData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRackRateChannelData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRackRateChannelData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRackRatePeriodsWithMissingRateInfo = function(params) {
        var url = endpoint + "Pms/GetRackRatePeriodsWithMissingRateInfo";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRackRatePeriodsWithMissingRateInfo"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRackRatePeriodsWithMissingRateInfo"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRackRates = function(params) {
        var url = endpoint + "Pms/GetRackRates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRackRates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRackRates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRatePeriod = function(params) {
        var url = endpoint + "Pms/GetRatePeriod";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRatePeriod"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRatePeriod"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRatePeriods = function(params) {
        var url = endpoint + "Pms/GetRatePeriods";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRatePeriods"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRatePeriods"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetReports = function(params) {
        var url = endpoint + "Pms/GetReports";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetReports"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetReports"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetResDayCheckedInGuests = function(params) {
        var url = endpoint + "Pms/GetResDayCheckedInGuests";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetResDayCheckedInGuests"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetResDayCheckedInGuests"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetReservation = function(params) {
        var url = endpoint + "Pms/GetReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetReservationCharges = function(params) {
        var url = endpoint + "Pms/GetReservationCharges";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetReservationCharges"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetReservationCharges"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetReservationFull = function(params) {
        var url = endpoint + "Pms/GetReservationFull";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetReservationFull"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetReservationFull"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetReservationGuest = function(params) {
        var url = endpoint + "Pms/GetReservationGuest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetReservationGuest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetReservationGuest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetReservationGuests = function(params) {
        var url = endpoint + "Pms/GetReservationGuests";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetReservationGuests"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetReservationGuests"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetReservationIDByExternalReservationID = function(params) {
        var url = endpoint + "Pms/GetReservationIDByExternalReservationID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetReservationIDByExternalReservationID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetReservationIDByExternalReservationID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetReservationList = function(params) {
        var url = endpoint + "Pms/GetReservationList";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetReservationList"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetReservationList"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetReservationStatuses = function(params) {
        var url = endpoint + "Pms/GetReservationStatuses";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetReservationStatuses"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetReservationStatuses"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoom = function(params) {
        var url = endpoint + "Pms/GetRoom";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoom"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoom"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomOccupancySummary = function(params) {
        var url = endpoint + "Pms/GetRoomOccupancySummary";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomOccupancySummary"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomOccupancySummary"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomPeriodNote = function(params) {
        var url = endpoint + "Pms/GetRoomPeriodNote";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomPeriodNote"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomPeriodNote"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomPeriodNoteByRoomIDAndPeriod = function(params) {
        var url = endpoint + "Pms/GetRoomPeriodNoteByRoomIDAndPeriod";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomPeriodNoteByRoomIDAndPeriod"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomPeriodNoteByRoomIDAndPeriod"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomPeriodNotes = function(params) {
        var url = endpoint + "Pms/GetRoomPeriodNotes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomPeriodNotes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomPeriodNotes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomPeriodNotesByWindow = function(params) {
        var url = endpoint + "Pms/GetRoomPeriodNotesByWindow";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomPeriodNotesByWindow"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomPeriodNotesByWindow"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomReservation = function(params) {
        var url = endpoint + "Pms/GetRoomReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomReservationArrivalGuests = function(params) {
        var url = endpoint + "Pms/GetRoomReservationArrivalGuests";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomReservationArrivalGuests"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomReservationArrivalGuests"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomReservationBreakdown = function(params) {
        var url = endpoint + "Pms/GetRoomReservationBreakdown";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomReservationBreakdown"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomReservationBreakdown"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomReservations = function(params) {
        var url = endpoint + "Pms/GetRoomReservations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomReservations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomReservations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomReservationStatuses = function(params) {
        var url = endpoint + "Pms/GetRoomReservationStatuses";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomReservationStatuses"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomReservationStatuses"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRooms = function(params) {
        var url = endpoint + "Pms/GetRooms";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRooms"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRooms"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomsByRoomTypeID = function(params) {
        var url = endpoint + "Pms/GetRoomsByRoomTypeID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomsByRoomTypeID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomsByRoomTypeID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomType = function(params) {
        var url = endpoint + "Pms/GetRoomType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomTypeBaseNames = function(params) {
        var url = endpoint + "Pms/GetRoomTypeBaseNames";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomTypeBaseNames"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomTypeBaseNames"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomTypeClassNames = function(params) {
        var url = endpoint + "Pms/GetRoomTypeClassNames";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomTypeClassNames"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomTypeClassNames"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomTypeIDByPartnerRoomTypeID = function(params) {
        var url = endpoint + "Pms/GetRoomTypeIDByPartnerRoomTypeID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomTypeIDByPartnerRoomTypeID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomTypeIDByPartnerRoomTypeID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomTypeIDByPartnerRoomTypeName = function(params) {
        var url = endpoint + "Pms/GetRoomTypeIDByPartnerRoomTypeName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomTypeIDByPartnerRoomTypeName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomTypeIDByPartnerRoomTypeName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomTypeMappingByPartner = function(params) {
        var url = endpoint + "Pms/GetRoomTypeMappingByPartner";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomTypeMappingByPartner"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomTypeMappingByPartner"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomTypeName = function(params) {
        var url = endpoint + "Pms/GetRoomTypeName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomTypeName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomTypeName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomTypeNames = function(params) {
        var url = endpoint + "Pms/GetRoomTypeNames";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomTypeNames"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomTypeNames"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomTypeNamesUnused = function(params) {
        var url = endpoint + "Pms/GetRoomTypeNamesUnused";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomTypeNamesUnused"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomTypeNamesUnused"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomTypes = function(params) {
        var url = endpoint + "Pms/GetRoomTypes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomTypes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomTypes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetRoomTypeStopSellData = function(params) {
        var url = endpoint + "Pms/GetRoomTypeStopSellData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetRoomTypeStopSellData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetRoomTypeStopSellData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetShiftLog = function(params) {
        var url = endpoint + "Pms/GetShiftLog";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetShiftLog"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetShiftLog"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetShiftsByBusinessDay = function(params) {
        var url = endpoint + "Pms/GetShiftsByBusinessDay";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetShiftsByBusinessDay"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetShiftsByBusinessDay"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetSMTPServer = function(params) {
        var url = endpoint + "Pms/GetSMTPServer";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetSMTPServer"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetSMTPServer"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetSMTPServers = function(params) {
        var url = endpoint + "Pms/GetSMTPServers";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetSMTPServers"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetSMTPServers"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetSplittingData = function(params) {
        var url = endpoint + "Pms/GetSplittingData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetSplittingData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetSplittingData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetTemplate = function(params) {
        var url = endpoint + "Pms/GetTemplate";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetTemplate"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetTemplate"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetTemplates = function(params) {
        var url = endpoint + "Pms/GetTemplates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetTemplates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetTemplates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetThirdPartyModificationTime = function(params) {
        var url = endpoint + "Pms/GetThirdPartyModificationTime";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetThirdPartyModificationTime"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetThirdPartyModificationTime"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetTotalVisitorsPerCountry = function(params) {
        var url = endpoint + "Pms/GetTotalVisitorsPerCountry";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetTotalVisitorsPerCountry"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetTotalVisitorsPerCountry"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetTotalVisitorsPerCountryUnassigned = function(params) {
        var url = endpoint + "Pms/GetTotalVisitorsPerCountryUnassigned";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetTotalVisitorsPerCountryUnassigned"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetTotalVisitorsPerCountryUnassigned"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetUnassignedGuestsForRoomReservation = function(params) {
        var url = endpoint + "Pms/GetUnassignedGuestsForRoomReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetUnassignedGuestsForRoomReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetUnassignedGuestsForRoomReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetUnassignedPartnersForOfferType = function(params) {
        var url = endpoint + "Pms/GetUnassignedPartnersForOfferType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetUnassignedPartnersForOfferType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetUnassignedPartnersForOfferType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetUser = function(params) {
        var url = endpoint + "Pms/GetUser";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetUser"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetUser"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetUserActions = function(params) {
        var url = endpoint + "Pms/GetUserActions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetUserActions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetUserActions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetUsers = function(params) {
        var url = endpoint + "Pms/GetUsers";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetUsers"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetUsers"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGetWuBookRCodesByReservationID = function(params) {
        var url = endpoint + "Pms/GetWuBookRCodesByReservationID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GetWuBookRCodesByReservationID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GetWuBookRCodesByReservationID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsGrantProductAPIKey = function(params) {
        var url = endpoint + "Pms/GrantProductAPIKey";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"GrantProductAPIKey"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"GrantProductAPIKey"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsHarnessTest = function(params) {
        var url = endpoint + "Pms/HarnessTest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"HarnessTest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"HarnessTest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsHotelAcceptsOTAChannelUpdates = function(params) {
        var url = endpoint + "Pms/HotelAcceptsOTAChannelUpdates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"HotelAcceptsOTAChannelUpdates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"HotelAcceptsOTAChannelUpdates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsHotelHasCacheData = function(params) {
        var url = endpoint + "Pms/HotelHasCacheData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"HotelHasCacheData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"HotelHasCacheData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsIndexLastMinuteDiscountsAll = function(params) {
        var url = endpoint + "Pms/IndexLastMinuteDiscountsAll";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"IndexLastMinuteDiscountsAll"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"IndexLastMinuteDiscountsAll"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsIndexMixedRateHotelPeriod = function(params) {
        var url = endpoint + "Pms/IndexMixedRateHotelPeriod";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"IndexMixedRateHotelPeriod"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"IndexMixedRateHotelPeriod"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsInitOTAHotelCTMAccount = function(params) {
        var url = endpoint + "Pms/InitOTAHotelCTMAccount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"InitOTAHotelCTMAccount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"InitOTAHotelCTMAccount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsInspectRoomTypeActivityLog = function(params) {
        var url = endpoint + "Pms/InspectRoomTypeActivityLog";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"InspectRoomTypeActivityLog"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"InspectRoomTypeActivityLog"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsLoadFormElementTextTranslations = function(params) {
        var url = endpoint + "Pms/LoadFormElementTextTranslations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"LoadFormElementTextTranslations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"LoadFormElementTextTranslations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsLoadGuiMessages = function(params) {
        var url = endpoint + "Pms/LoadGuiMessages";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"LoadGuiMessages"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"LoadGuiMessages"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsLoadReportTextsPivotedByID = function(params) {
        var url = endpoint + "Pms/LoadReportTextsPivotedByID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"LoadReportTextsPivotedByID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"LoadReportTextsPivotedByID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsLogReservationCorrespondenceAction = function(params) {
        var url = endpoint + "Pms/LogReservationCorrespondenceAction";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"LogReservationCorrespondenceAction"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"LogReservationCorrespondenceAction"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsMakeReservation = function(params) {
        var url = endpoint + "Pms/MakeReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"MakeReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"MakeReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsMakeReservationViaGateway = function(params) {
        var url = endpoint + "Pms/MakeReservationViaGateway";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"MakeReservationViaGateway"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"MakeReservationViaGateway"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsMakeRoomReservation = function(params) {
        var url = endpoint + "Pms/MakeRoomReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"MakeRoomReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"MakeRoomReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsMakeRoomReservationGroup = function(params) {
        var url = endpoint + "Pms/MakeRoomReservationGroup";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"MakeRoomReservationGroup"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"MakeRoomReservationGroup"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsMakeRoomReservationGroupWithDiscount = function(params) {
        var url = endpoint + "Pms/MakeRoomReservationGroupWithDiscount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"MakeRoomReservationGroupWithDiscount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"MakeRoomReservationGroupWithDiscount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsMarkFormAsSeen = function(params) {
        var url = endpoint + "Pms/MarkFormAsSeen";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"MarkFormAsSeen"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"MarkFormAsSeen"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsMarkFormElementAsSeen = function(params) {
        var url = endpoint + "Pms/MarkFormElementAsSeen";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"MarkFormElementAsSeen"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"MarkFormElementAsSeen"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsMigrateRoom = function(params) {
        var url = endpoint + "Pms/MigrateRoom";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"MigrateRoom"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"MigrateRoom"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsMonitorChannelManagerStatus = function(params) {
        var url = endpoint + "Pms/MonitorChannelManagerStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"MonitorChannelManagerStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"MonitorChannelManagerStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsMonitorEmergencyPartnerDeactivation = function(params) {
        var url = endpoint + "Pms/MonitorEmergencyPartnerDeactivation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"MonitorEmergencyPartnerDeactivation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"MonitorEmergencyPartnerDeactivation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewExhibitionPeriod = function(params) {
        var url = endpoint + "Pms/NewExhibitionPeriod";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewExhibitionPeriod"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewExhibitionPeriod"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewGuest = function(params) {
        var url = endpoint + "Pms/NewGuest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewGuest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewGuest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewOfferType = function(params) {
        var url = endpoint + "Pms/NewOfferType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewOfferType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewOfferType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewOfferTypeAsDiscount = function(params) {
        var url = endpoint + "Pms/NewOfferTypeAsDiscount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewOfferTypeAsDiscount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewOfferTypeAsDiscount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewOfferTypeAsDiscountOTA = function(params) {
        var url = endpoint + "Pms/NewOfferTypeAsDiscountOTA";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewOfferTypeAsDiscountOTA"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewOfferTypeAsDiscountOTA"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewOfferTypeOTA = function(params) {
        var url = endpoint + "Pms/NewOfferTypeOTA";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewOfferTypeOTA"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewOfferTypeOTA"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewPartner = function(params) {
        var url = endpoint + "Pms/NewPartner";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewPartner"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewPartner"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewRackRate = function(params) {
        var url = endpoint + "Pms/NewRackRate";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewRackRate"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewRackRate"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewRackRatePeriod = function(params) {
        var url = endpoint + "Pms/NewRackRatePeriod";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewRackRatePeriod"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewRackRatePeriod"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewRoom = function(params) {
        var url = endpoint + "Pms/NewRoom";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewRoom"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewRoom"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewRoomPeriodNote = function(params) {
        var url = endpoint + "Pms/NewRoomPeriodNote";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewRoomPeriodNote"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewRoomPeriodNote"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewRoomType = function(params) {
        var url = endpoint + "Pms/NewRoomType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewRoomType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewRoomType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewRoomTypeName = function(params) {
        var url = endpoint + "Pms/NewRoomTypeName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewRoomTypeName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewRoomTypeName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewRoomTypeWithAutoName = function(params) {
        var url = endpoint + "Pms/NewRoomTypeWithAutoName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewRoomTypeWithAutoName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewRoomTypeWithAutoName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewSMTPServer = function(params) {
        var url = endpoint + "Pms/NewSMTPServer";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewSMTPServer"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewSMTPServer"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewTemplate = function(params) {
        var url = endpoint + "Pms/NewTemplate";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewTemplate"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewTemplate"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNewUser = function(params) {
        var url = endpoint + "Pms/NewUser";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NewUser"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NewUser"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNotify = function(params) {
        var url = endpoint + "Pms/Notify";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"Notify"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"Notify"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNotifyChannelModDoubleChecks = function(params) {
        var url = endpoint + "Pms/NotifyChannelModDoubleChecks";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NotifyChannelModDoubleChecks"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NotifyChannelModDoubleChecks"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNotifyOutstandingCheckouts = function(params) {
        var url = endpoint + "Pms/NotifyOutstandingCheckouts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NotifyOutstandingCheckouts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NotifyOutstandingCheckouts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNotifyOutstandingOTAXMLActivations = function(params) {
        var url = endpoint + "Pms/NotifyOutstandingOTAXMLActivations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NotifyOutstandingOTAXMLActivations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NotifyOutstandingOTAXMLActivations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsNotifyTodaysPriorityNotes = function(params) {
        var url = endpoint + "Pms/NotifyTodaysPriorityNotes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"NotifyTodaysPriorityNotes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"NotifyTodaysPriorityNotes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsOTAXMLTestAccountViewAvailability = function(params) {
        var url = endpoint + "Pms/OTAXMLTestAccountViewAvailability";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"OTAXMLTestAccountViewAvailability"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"OTAXMLTestAccountViewAvailability"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsOTAXMLTestAccountViewRates = function(params) {
        var url = endpoint + "Pms/OTAXMLTestAccountViewRates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"OTAXMLTestAccountViewRates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"OTAXMLTestAccountViewRates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsPopulateOTAExternalRoomReservationIDs = function(params) {
        var url = endpoint + "Pms/PopulateOTAExternalRoomReservationIDs";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"PopulateOTAExternalRoomReservationIDs"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"PopulateOTAExternalRoomReservationIDs"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsProduceChannelManagerExceptionDigest = function(params) {
        var url = endpoint + "Pms/ProduceChannelManagerExceptionDigest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ProduceChannelManagerExceptionDigest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ProduceChannelManagerExceptionDigest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsProduceDailyActionSchedule = function(params) {
        var url = endpoint + "Pms/ProduceDailyActionSchedule";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ProduceDailyActionSchedule"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ProduceDailyActionSchedule"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsProduceDailyExtraPaymentList = function(params) {
        var url = endpoint + "Pms/ProduceDailyExtraPaymentList";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ProduceDailyExtraPaymentList"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ProduceDailyExtraPaymentList"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsProduceMonitorHeartbeatDigest = function(params) {
        var url = endpoint + "Pms/ProduceMonitorHeartbeatDigest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ProduceMonitorHeartbeatDigest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ProduceMonitorHeartbeatDigest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsProducePMSExceptionDigest = function(params) {
        var url = endpoint + "Pms/ProducePMSExceptionDigest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ProducePMSExceptionDigest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ProducePMSExceptionDigest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsProduceSyncTestHeartbeatDigest = function(params) {
        var url = endpoint + "Pms/ProduceSyncTestHeartbeatDigest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ProduceSyncTestHeartbeatDigest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ProduceSyncTestHeartbeatDigest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsPruneExpiredPartners = function(params) {
        var url = endpoint + "Pms/PruneExpiredPartners";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"PruneExpiredPartners"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"PruneExpiredPartners"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRecordThirdPartyModificationTime = function(params) {
        var url = endpoint + "Pms/RecordThirdPartyModificationTime";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RecordThirdPartyModificationTime"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RecordThirdPartyModificationTime"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRegisterChannelManagerException = function(params) {
        var url = endpoint + "Pms/RegisterChannelManagerException";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RegisterChannelManagerException"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RegisterChannelManagerException"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRegisterChannelManagerExceptionsAlerted = function(params) {
        var url = endpoint + "Pms/RegisterChannelManagerExceptionsAlerted";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RegisterChannelManagerExceptionsAlerted"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RegisterChannelManagerExceptionsAlerted"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRegisterMonitorHeartbeatInit = function(params) {
        var url = endpoint + "Pms/RegisterMonitorHeartbeatInit";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RegisterMonitorHeartbeatInit"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RegisterMonitorHeartbeatInit"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRegisterMonitorHeartbeatStatus = function(params) {
        var url = endpoint + "Pms/RegisterMonitorHeartbeatStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RegisterMonitorHeartbeatStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RegisterMonitorHeartbeatStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRegisterPMSException = function(params) {
        var url = endpoint + "Pms/RegisterPMSException";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RegisterPMSException"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RegisterPMSException"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRegisterPMSExceptionsAlerted = function(params) {
        var url = endpoint + "Pms/RegisterPMSExceptionsAlerted";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RegisterPMSExceptionsAlerted"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RegisterPMSExceptionsAlerted"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRegisterSyncTestHeartbeatInit = function(params) {
        var url = endpoint + "Pms/RegisterSyncTestHeartbeatInit";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RegisterSyncTestHeartbeatInit"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RegisterSyncTestHeartbeatInit"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRegisterSyncTestHeartbeatStatus = function(params) {
        var url = endpoint + "Pms/RegisterSyncTestHeartbeatStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RegisterSyncTestHeartbeatStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RegisterSyncTestHeartbeatStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRegisterThirdPartyEditFailure = function(params) {
        var url = endpoint + "Pms/RegisterThirdPartyEditFailure";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RegisterThirdPartyEditFailure"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RegisterThirdPartyEditFailure"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsReleaseOutOfOrderRoom = function(params) {
        var url = endpoint + "Pms/ReleaseOutOfOrderRoom";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ReleaseOutOfOrderRoom"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ReleaseOutOfOrderRoom"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsReportCancelConfirmedToThirdParty = function(params) {
        var url = endpoint + "Pms/ReportCancelConfirmedToThirdParty";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ReportCancelConfirmedToThirdParty"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ReportCancelConfirmedToThirdParty"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsReportChannelActionAttempt = function(params) {
        var url = endpoint + "Pms/ReportChannelActionAttempt";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ReportChannelActionAttempt"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ReportChannelActionAttempt"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsReportChannelActionSuccess = function(params) {
        var url = endpoint + "Pms/ReportChannelActionSuccess";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ReportChannelActionSuccess"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ReportChannelActionSuccess"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsReportChannelPull = function(params) {
        var url = endpoint + "Pms/ReportChannelPull";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ReportChannelPull"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ReportChannelPull"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsReportChannelUpdateCycle = function(params) {
        var url = endpoint + "Pms/ReportChannelUpdateCycle";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ReportChannelUpdateCycle"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ReportChannelUpdateCycle"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsReportResConfirmedToThirdParty = function(params) {
        var url = endpoint + "Pms/ReportResConfirmedToThirdParty";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ReportResConfirmedToThirdParty"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ReportResConfirmedToThirdParty"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRequestProductAPIKey = function(params) {
        var url = endpoint + "Pms/RequestProductAPIKey";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RequestProductAPIKey"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RequestProductAPIKey"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRestoreRackRates = function(params) {
        var url = endpoint + "Pms/RestoreRackRates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RestoreRackRates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RestoreRackRates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRetrieveCorrespondenceAction = function(params) {
        var url = endpoint + "Pms/RetrieveCorrespondenceAction";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RetrieveCorrespondenceAction"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RetrieveCorrespondenceAction"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRetrieveOTAReservations = function(params) {
        var url = endpoint + "Pms/RetrieveOTAReservations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RetrieveOTAReservations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RetrieveOTAReservations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRetrieveOTAReservationsCancel = function(params) {
        var url = endpoint + "Pms/RetrieveOTAReservationsCancel";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RetrieveOTAReservationsCancel"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RetrieveOTAReservationsCancel"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRetrieveOTAReservationsModify = function(params) {
        var url = endpoint + "Pms/RetrieveOTAReservationsModify";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RetrieveOTAReservationsModify"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RetrieveOTAReservationsModify"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRetrieveOTAReservationsNew = function(params) {
        var url = endpoint + "Pms/RetrieveOTAReservationsNew";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RetrieveOTAReservationsNew"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RetrieveOTAReservationsNew"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRetrieveReservationActions = function(params) {
        var url = endpoint + "Pms/RetrieveReservationActions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RetrieveReservationActions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RetrieveReservationActions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsRetrieveReservationCorrespondenceActions = function(params) {
        var url = endpoint + "Pms/RetrieveReservationCorrespondenceActions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"RetrieveReservationCorrespondenceActions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"RetrieveReservationCorrespondenceActions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSaveFormElementText = function(params) {
        var url = endpoint + "Pms/SaveFormElementText";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SaveFormElementText"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SaveFormElementText"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsScheduleChannelActionsByRoomType = function(params) {
        var url = endpoint + "Pms/ScheduleChannelActionsByRoomType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ScheduleChannelActionsByRoomType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ScheduleChannelActionsByRoomType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsScheduleCompleteRateActionSync = function(params) {
        var url = endpoint + "Pms/ScheduleCompleteRateActionSync";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ScheduleCompleteRateActionSync"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ScheduleCompleteRateActionSync"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSearchGuests = function(params) {
        var url = endpoint + "Pms/SearchGuests";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SearchGuests"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SearchGuests"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSearchReservations = function(params) {
        var url = endpoint + "Pms/SearchReservations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SearchReservations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SearchReservations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSetBookingDotComDeviceCookie = function(params) {
        var url = endpoint + "Pms/SetBookingDotComDeviceCookie";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SetBookingDotComDeviceCookie"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SetBookingDotComDeviceCookie"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSetExternalRoomReservationID = function(params) {
        var url = endpoint + "Pms/SetExternalRoomReservationID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SetExternalRoomReservationID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SetExternalRoomReservationID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSetGuestTouristFeeExemption = function(params) {
        var url = endpoint + "Pms/SetGuestTouristFeeExemption";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SetGuestTouristFeeExemption"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SetGuestTouristFeeExemption"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSetOfferTypeMemberDiscount = function(params) {
        var url = endpoint + "Pms/SetOfferTypeMemberDiscount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SetOfferTypeMemberDiscount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SetOfferTypeMemberDiscount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSetOfferTypeMemberDiscountDays = function(params) {
        var url = endpoint + "Pms/SetOfferTypeMemberDiscountDays";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SetOfferTypeMemberDiscountDays"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SetOfferTypeMemberDiscountDays"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSetReservationStatus = function(params) {
        var url = endpoint + "Pms/SetReservationStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SetReservationStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SetReservationStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSetRoomReservationNoShow = function(params) {
        var url = endpoint + "Pms/SetRoomReservationNoShow";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SetRoomReservationNoShow"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SetRoomReservationNoShow"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsShuffleRoomOrder = function(params) {
        var url = endpoint + "Pms/ShuffleRoomOrder";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ShuffleRoomOrder"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ShuffleRoomOrder"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsShuffleRoomTypeOrder = function(params) {
        var url = endpoint + "Pms/ShuffleRoomTypeOrder";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ShuffleRoomTypeOrder"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ShuffleRoomTypeOrder"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSignalEmergencyPartnerDeactivation = function(params) {
        var url = endpoint + "Pms/SignalEmergencyPartnerDeactivation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SignalEmergencyPartnerDeactivation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SignalEmergencyPartnerDeactivation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsSyncCachesToConfig = function(params) {
        var url = endpoint + "Pms/SyncCachesToConfig";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"SyncCachesToConfig"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"SyncCachesToConfig"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsUnassignGuestFromReservation = function(params) {
        var url = endpoint + "Pms/UnassignGuestFromReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"UnassignGuestFromReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"UnassignGuestFromReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsUnassignGuestFromRoomByRoomReservation = function(params) {
        var url = endpoint + "Pms/UnassignGuestFromRoomByRoomReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"UnassignGuestFromRoomByRoomReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"UnassignGuestFromRoomByRoomReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsUnassignPartnerFromChannel = function(params) {
        var url = endpoint + "Pms/UnassignPartnerFromChannel";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"UnassignPartnerFromChannel"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"UnassignPartnerFromChannel"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsUndoRoomReservationCheckIn = function(params) {
        var url = endpoint + "Pms/UndoRoomReservationCheckIn";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"UndoRoomReservationCheckIn"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"UndoRoomReservationCheckIn"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsUndoRoomReservationCheckOut = function(params) {
        var url = endpoint + "Pms/UndoRoomReservationCheckOut";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"UndoRoomReservationCheckOut"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"UndoRoomReservationCheckOut"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsUndoRoomReservationNoShow = function(params) {
        var url = endpoint + "Pms/UndoRoomReservationNoShow";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"UndoRoomReservationNoShow"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"UndoRoomReservationNoShow"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsUpdateWuBookRCodes = function(params) {
        var url = endpoint + "Pms/UpdateWuBookRCodes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"UpdateWuBookRCodes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"UpdateWuBookRCodes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsValidateCheckIn = function(params) {
        var url = endpoint + "Pms/ValidateCheckIn";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ValidateCheckIn"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ValidateCheckIn"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsValidateCheckOut = function(params) {
        var url = endpoint + "Pms/ValidateCheckOut";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ValidateCheckOut"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ValidateCheckOut"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsValidateNoShow = function(params) {
        var url = endpoint + "Pms/ValidateNoShow";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ValidateNoShow"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ValidateNoShow"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsValidateRoomResGroupRequest = function(params) {
        var url = endpoint + "Pms/ValidateRoomResGroupRequest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"ValidateRoomResGroupRequest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"ValidateRoomResGroupRequest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyCacheCoverage = function(params) {
        var url = endpoint + "Pms/VerifyCacheCoverage";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyCacheCoverage"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyCacheCoverage"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyNoRecentOverbookings = function(params) {
        var url = endpoint + "Pms/VerifyNoRecentOverbookings";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyNoRecentOverbookings"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyNoRecentOverbookings"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyNotificationEvent = function(params) {
        var url = endpoint + "Pms/VerifyNotificationEvent";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyNotificationEvent"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyNotificationEvent"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyNotificationEventsByReservation = function(params) {
        var url = endpoint + "Pms/VerifyNotificationEventsByReservation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyNotificationEventsByReservation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyNotificationEventsByReservation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyNotificationEventsByReservationID = function(params) {
        var url = endpoint + "Pms/VerifyNotificationEventsByReservationID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyNotificationEventsByReservationID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyNotificationEventsByReservationID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyRackRateAllotmentClamping = function(params) {
        var url = endpoint + "Pms/VerifyRackRateAllotmentClamping";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyRackRateAllotmentClamping"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyRackRateAllotmentClamping"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyRackRateCapacityConsistency = function(params) {
        var url = endpoint + "Pms/VerifyRackRateCapacityConsistency";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyRackRateCapacityConsistency"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyRackRateCapacityConsistency"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyRackRateDayCoverage = function(params) {
        var url = endpoint + "Pms/VerifyRackRateDayCoverage";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyRackRateDayCoverage"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyRackRateDayCoverage"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyRoomAvailabilityConsistency = function(params) {
        var url = endpoint + "Pms/VerifyRoomAvailabilityConsistency";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyRoomAvailabilityConsistency"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyRoomAvailabilityConsistency"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyRoomResAssignmentConsistency = function(params) {
        var url = endpoint + "Pms/VerifyRoomResAssignmentConsistency";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyRoomResAssignmentConsistency"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyRoomResAssignmentConsistency"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyRoomResBreakdownConsistency = function(params) {
        var url = endpoint + "Pms/VerifyRoomResBreakdownConsistency";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyRoomResBreakdownConsistency"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyRoomResBreakdownConsistency"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyRoomResBreakdownMissingOK = function(params) {
        var url = endpoint + "Pms/VerifyRoomResBreakdownMissingOK";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyRoomResBreakdownMissingOK"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyRoomResBreakdownMissingOK"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.PmsVerifyThirdPartyEditConsistency = function(params) {
        var url = endpoint + "Pms/VerifyThirdPartyEditConsistency";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Pms"
                        ,"VerifyThirdPartyEditConsistency"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Pms"
                        ,"VerifyThirdPartyEditConsistency"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsAddBillingSnapshotGuest = function(params) {
        var url = endpoint + "Accounts/AddBillingSnapshotGuest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"AddBillingSnapshotGuest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"AddBillingSnapshotGuest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsAddCustomerInvoiceGuest = function(params) {
        var url = endpoint + "Accounts/AddCustomerInvoiceGuest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"AddCustomerInvoiceGuest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"AddCustomerInvoiceGuest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsCloseBill = function(params) {
        var url = endpoint + "Accounts/CloseBill";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"CloseBill"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"CloseBill"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsCloseFolioBill = function(params) {
        var url = endpoint + "Accounts/CloseFolioBill";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"CloseFolioBill"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"CloseFolioBill"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsCloseJournalSegment = function(params) {
        var url = endpoint + "Accounts/CloseJournalSegment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"CloseJournalSegment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"CloseJournalSegment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsClosePMSBill = function(params) {
        var url = endpoint + "Accounts/ClosePMSBill";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ClosePMSBill"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ClosePMSBill"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsClosePOSBill = function(params) {
        var url = endpoint + "Accounts/ClosePOSBill";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ClosePOSBill"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ClosePOSBill"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsCounterPOSBill = function(params) {
        var url = endpoint + "Accounts/CounterPOSBill";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"CounterPOSBill"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"CounterPOSBill"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsCreateCounterInvoice = function(params) {
        var url = endpoint + "Accounts/CreateCounterInvoice";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"CreateCounterInvoice"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"CreateCounterInvoice"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsCreateCustomerInvoice = function(params) {
        var url = endpoint + "Accounts/CreateCustomerInvoice";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"CreateCustomerInvoice"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"CreateCustomerInvoice"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsDeleteProduct = function(params) {
        var url = endpoint + "Accounts/DeleteProduct";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"DeleteProduct"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"DeleteProduct"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsDeleteTransaction = function(params) {
        var url = endpoint + "Accounts/DeleteTransaction";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"DeleteTransaction"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"DeleteTransaction"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsEditFolioDetails = function(params) {
        var url = endpoint + "Accounts/EditFolioDetails";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"EditFolioDetails"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"EditFolioDetails"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsEditProduct = function(params) {
        var url = endpoint + "Accounts/EditProduct";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"EditProduct"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"EditProduct"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsEditTransaction = function(params) {
        var url = endpoint + "Accounts/EditTransaction";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"EditTransaction"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"EditTransaction"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAccount = function(params) {
        var url = endpoint + "Accounts/GetAccount";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAccount"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAccount"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAccounts = function(params) {
        var url = endpoint + "Accounts/GetAccounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAccounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAccounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAccountTypes = function(params) {
        var url = endpoint + "Accounts/GetAccountTypes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAccountTypes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAccountTypes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetActivePaymentTills = function(params) {
        var url = endpoint + "Accounts/GetActivePaymentTills";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetActivePaymentTills"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetActivePaymentTills"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAllProducts = function(params) {
        var url = endpoint + "Accounts/GetAllProducts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAllProducts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAllProducts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAuditTrailBillResnapshotAggregates = function(params) {
        var url = endpoint + "Accounts/GetAuditTrailBillResnapshotAggregates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAuditTrailBillResnapshotAggregates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAuditTrailBillResnapshotAggregates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAuditTrailBillResnapshotData = function(params) {
        var url = endpoint + "Accounts/GetAuditTrailBillResnapshotData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAuditTrailBillResnapshotData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAuditTrailBillResnapshotData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAuditTrailCounterInvoiceAggregates = function(params) {
        var url = endpoint + "Accounts/GetAuditTrailCounterInvoiceAggregates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAuditTrailCounterInvoiceAggregates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAuditTrailCounterInvoiceAggregates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAuditTrailCounterInvoiceData = function(params) {
        var url = endpoint + "Accounts/GetAuditTrailCounterInvoiceData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAuditTrailCounterInvoiceData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAuditTrailCounterInvoiceData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAuditTrailCounterReceiptAggregates = function(params) {
        var url = endpoint + "Accounts/GetAuditTrailCounterReceiptAggregates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAuditTrailCounterReceiptAggregates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAuditTrailCounterReceiptAggregates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAuditTrailCounterReceiptData = function(params) {
        var url = endpoint + "Accounts/GetAuditTrailCounterReceiptData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAuditTrailCounterReceiptData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAuditTrailCounterReceiptData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAuditTrailRefundAggregates = function(params) {
        var url = endpoint + "Accounts/GetAuditTrailRefundAggregates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAuditTrailRefundAggregates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAuditTrailRefundAggregates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAuditTrailRefundData = function(params) {
        var url = endpoint + "Accounts/GetAuditTrailRefundData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAuditTrailRefundData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAuditTrailRefundData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAuditTrailSegmentResnapshotAggregates = function(params) {
        var url = endpoint + "Accounts/GetAuditTrailSegmentResnapshotAggregates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAuditTrailSegmentResnapshotAggregates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAuditTrailSegmentResnapshotAggregates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetAuditTrailSegmentResnapshotData = function(params) {
        var url = endpoint + "Accounts/GetAuditTrailSegmentResnapshotData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetAuditTrailSegmentResnapshotData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetAuditTrailSegmentResnapshotData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBalanceSummaryCharges = function(params) {
        var url = endpoint + "Accounts/GetBalanceSummaryCharges";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBalanceSummaryCharges"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBalanceSummaryCharges"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingBalance = function(params) {
        var url = endpoint + "Accounts/GetBillingBalance";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingBalance"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingBalance"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingBalanceTotalOnly = function(params) {
        var url = endpoint + "Accounts/GetBillingBalanceTotalOnly";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingBalanceTotalOnly"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingBalanceTotalOnly"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingGuestName = function(params) {
        var url = endpoint + "Accounts/GetBillingGuestName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingGuestName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingGuestName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingSnapshot = function(params) {
        var url = endpoint + "Accounts/GetBillingSnapshot";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingSnapshot"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingSnapshot"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingSnapshotAncillaryGuests = function(params) {
        var url = endpoint + "Accounts/GetBillingSnapshotAncillaryGuests";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingSnapshotAncillaryGuests"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingSnapshotAncillaryGuests"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingSnapshotBalance = function(params) {
        var url = endpoint + "Accounts/GetBillingSnapshotBalance";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingSnapshotBalance"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingSnapshotBalance"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingSnapshotInvoiceAccounts = function(params) {
        var url = endpoint + "Accounts/GetBillingSnapshotInvoiceAccounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingSnapshotInvoiceAccounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingSnapshotInvoiceAccounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingSnapshotInvoiceCharges = function(params) {
        var url = endpoint + "Accounts/GetBillingSnapshotInvoiceCharges";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingSnapshotInvoiceCharges"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingSnapshotInvoiceCharges"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingSnapshotInvoices = function(params) {
        var url = endpoint + "Accounts/GetBillingSnapshotInvoices";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingSnapshotInvoices"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingSnapshotInvoices"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingSnapshotInvoiceTaxes = function(params) {
        var url = endpoint + "Accounts/GetBillingSnapshotInvoiceTaxes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingSnapshotInvoiceTaxes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingSnapshotInvoiceTaxes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingSnapshotReceiptAccounts = function(params) {
        var url = endpoint + "Accounts/GetBillingSnapshotReceiptAccounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingSnapshotReceiptAccounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingSnapshotReceiptAccounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingSnapshotReceiptPayments = function(params) {
        var url = endpoint + "Accounts/GetBillingSnapshotReceiptPayments";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingSnapshotReceiptPayments"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingSnapshotReceiptPayments"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingSnapshotReceipts = function(params) {
        var url = endpoint + "Accounts/GetBillingSnapshotReceipts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingSnapshotReceipts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingSnapshotReceipts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingSnapshots = function(params) {
        var url = endpoint + "Accounts/GetBillingSnapshots";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingSnapshots"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingSnapshots"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingStatus = function(params) {
        var url = endpoint + "Accounts/GetBillingStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBillingTransactions = function(params) {
        var url = endpoint + "Accounts/GetBillingTransactions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBillingTransactions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBillingTransactions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBills = function(params) {
        var url = endpoint + "Accounts/GetBills";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBills"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBills"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetBreakfastSummary = function(params) {
        var url = endpoint + "Accounts/GetBreakfastSummary";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetBreakfastSummary"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetBreakfastSummary"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetChargeAccounts = function(params) {
        var url = endpoint + "Accounts/GetChargeAccounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetChargeAccounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetChargeAccounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetCurrentJournalSegmentSnapshotID = function(params) {
        var url = endpoint + "Accounts/GetCurrentJournalSegmentSnapshotID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetCurrentJournalSegmentSnapshotID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetCurrentJournalSegmentSnapshotID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetCurrentSegmentStartDay = function(params) {
        var url = endpoint + "Accounts/GetCurrentSegmentStartDay";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetCurrentSegmentStartDay"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetCurrentSegmentStartDay"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetCustomerInvoicableTransactions = function(params) {
        var url = endpoint + "Accounts/GetCustomerInvoicableTransactions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetCustomerInvoicableTransactions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetCustomerInvoicableTransactions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetCustomerInvoice = function(params) {
        var url = endpoint + "Accounts/GetCustomerInvoice";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetCustomerInvoice"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetCustomerInvoice"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetCustomerInvoiceAccounts = function(params) {
        var url = endpoint + "Accounts/GetCustomerInvoiceAccounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetCustomerInvoiceAccounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetCustomerInvoiceAccounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetCustomerInvoiceAncillaryGuests = function(params) {
        var url = endpoint + "Accounts/GetCustomerInvoiceAncillaryGuests";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetCustomerInvoiceAncillaryGuests"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetCustomerInvoiceAncillaryGuests"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetCustomerInvoiceBreakdownAndAccounts = function(params) {
        var url = endpoint + "Accounts/GetCustomerInvoiceBreakdownAndAccounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetCustomerInvoiceBreakdownAndAccounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetCustomerInvoiceBreakdownAndAccounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetCustomerInvoiceGuestName = function(params) {
        var url = endpoint + "Accounts/GetCustomerInvoiceGuestName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetCustomerInvoiceGuestName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetCustomerInvoiceGuestName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetCustomerInvoiceRoomTypeBreakdown = function(params) {
        var url = endpoint + "Accounts/GetCustomerInvoiceRoomTypeBreakdown";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetCustomerInvoiceRoomTypeBreakdown"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetCustomerInvoiceRoomTypeBreakdown"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetFolioTransactions = function(params) {
        var url = endpoint + "Accounts/GetFolioTransactions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetFolioTransactions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetFolioTransactions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetInvoicableTransactions = function(params) {
        var url = endpoint + "Accounts/GetInvoicableTransactions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetInvoicableTransactions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetInvoicableTransactions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetInvoice = function(params) {
        var url = endpoint + "Accounts/GetInvoice";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetInvoice"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetInvoice"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetInvoiceAccounts = function(params) {
        var url = endpoint + "Accounts/GetInvoiceAccounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetInvoiceAccounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetInvoiceAccounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetInvoiceBreakdownAndAccounts = function(params) {
        var url = endpoint + "Accounts/GetInvoiceBreakdownAndAccounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetInvoiceBreakdownAndAccounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetInvoiceBreakdownAndAccounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetInvoiceGuestName = function(params) {
        var url = endpoint + "Accounts/GetInvoiceGuestName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetInvoiceGuestName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetInvoiceGuestName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetInvoiceRoomTypeBreakdown = function(params) {
        var url = endpoint + "Accounts/GetInvoiceRoomTypeBreakdown";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetInvoiceRoomTypeBreakdown"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetInvoiceRoomTypeBreakdown"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalPeriodSnapshotBillingGroups = function(params) {
        var url = endpoint + "Accounts/GetJournalPeriodSnapshotBillingGroups";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalPeriodSnapshotBillingGroups"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalPeriodSnapshotBillingGroups"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalPeriodSnapshotCharges = function(params) {
        var url = endpoint + "Accounts/GetJournalPeriodSnapshotCharges";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalPeriodSnapshotCharges"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalPeriodSnapshotCharges"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegment = function(params) {
        var url = endpoint + "Accounts/GetJournalSegment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegmentEndTimesByDay = function(params) {
        var url = endpoint + "Accounts/GetJournalSegmentEndTimesByDay";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegmentEndTimesByDay"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegmentEndTimesByDay"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegmentsByTill = function(params) {
        var url = endpoint + "Accounts/GetJournalSegmentsByTill";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegmentsByTill"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegmentsByTill"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegmentSnapshot = function(params) {
        var url = endpoint + "Accounts/GetJournalSegmentSnapshot";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshot"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshot"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegmentSnapshotBillingGroups = function(params) {
        var url = endpoint + "Accounts/GetJournalSegmentSnapshotBillingGroups";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotBillingGroups"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotBillingGroups"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegmentSnapshotCharges = function(params) {
        var url = endpoint + "Accounts/GetJournalSegmentSnapshotCharges";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotCharges"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotCharges"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegmentSnapshotClosedPayments = function(params) {
        var url = endpoint + "Accounts/GetJournalSegmentSnapshotClosedPayments";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotClosedPayments"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotClosedPayments"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegmentSnapshotOpenPayments = function(params) {
        var url = endpoint + "Accounts/GetJournalSegmentSnapshotOpenPayments";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotOpenPayments"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotOpenPayments"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegmentSnapshots = function(params) {
        var url = endpoint + "Accounts/GetJournalSegmentSnapshots";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshots"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshots"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegmentSnapshotSalesBillingGroups = function(params) {
        var url = endpoint + "Accounts/GetJournalSegmentSnapshotSalesBillingGroups";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotSalesBillingGroups"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotSalesBillingGroups"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegmentSnapshotSalesCharges = function(params) {
        var url = endpoint + "Accounts/GetJournalSegmentSnapshotSalesCharges";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotSalesCharges"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegmentSnapshotSalesCharges"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetJournalSegmentStartTimesByDay = function(params) {
        var url = endpoint + "Accounts/GetJournalSegmentStartTimesByDay";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetJournalSegmentStartTimesByDay"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetJournalSegmentStartTimesByDay"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetOccupiedRooms = function(params) {
        var url = endpoint + "Accounts/GetOccupiedRooms";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetOccupiedRooms"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetOccupiedRooms"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetPaymentAccounts = function(params) {
        var url = endpoint + "Accounts/GetPaymentAccounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetPaymentAccounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetPaymentAccounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetPaymentGuests = function(params) {
        var url = endpoint + "Accounts/GetPaymentGuests";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetPaymentGuests"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetPaymentGuests"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetPrimaryReservationBillingID = function(params) {
        var url = endpoint + "Accounts/GetPrimaryReservationBillingID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetPrimaryReservationBillingID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetPrimaryReservationBillingID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetProduct = function(params) {
        var url = endpoint + "Accounts/GetProduct";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetProduct"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetProduct"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetProductBillingGroups = function(params) {
        var url = endpoint + "Accounts/GetProductBillingGroups";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetProductBillingGroups"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetProductBillingGroups"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetProducts = function(params) {
        var url = endpoint + "Accounts/GetProducts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetProducts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetProducts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetProductsByType = function(params) {
        var url = endpoint + "Accounts/GetProductsByType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetProductsByType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetProductsByType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetProvisionalBillingBalance = function(params) {
        var url = endpoint + "Accounts/GetProvisionalBillingBalance";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetProvisionalBillingBalance"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetProvisionalBillingBalance"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReceipt = function(params) {
        var url = endpoint + "Accounts/GetReceipt";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReceipt"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReceipt"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReceiptAccounts = function(params) {
        var url = endpoint + "Accounts/GetReceiptAccounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReceiptAccounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReceiptAccounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReceiptGuestName = function(params) {
        var url = endpoint + "Accounts/GetReceiptGuestName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReceiptGuestName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReceiptGuestName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReceiptInvoiceAccounts = function(params) {
        var url = endpoint + "Accounts/GetReceiptInvoiceAccounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReceiptInvoiceAccounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReceiptInvoiceAccounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReceiptInvoiceCharges = function(params) {
        var url = endpoint + "Accounts/GetReceiptInvoiceCharges";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReceiptInvoiceCharges"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReceiptInvoiceCharges"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReceiptInvoiceTaxes = function(params) {
        var url = endpoint + "Accounts/GetReceiptInvoiceTaxes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReceiptInvoiceTaxes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReceiptInvoiceTaxes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReceiptPayments = function(params) {
        var url = endpoint + "Accounts/GetReceiptPayments";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReceiptPayments"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReceiptPayments"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetRegisterablePayments = function(params) {
        var url = endpoint + "Accounts/GetRegisterablePayments";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetRegisterablePayments"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetRegisterablePayments"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReleasableTransactions = function(params) {
        var url = endpoint + "Accounts/GetReleasableTransactions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReleasableTransactions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReleasableTransactions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReservationBalance = function(params) {
        var url = endpoint + "Accounts/GetReservationBalance";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReservationBalance"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReservationBalance"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReservationBillingStatus = function(params) {
        var url = endpoint + "Accounts/GetReservationBillingStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReservationBillingStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReservationBillingStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReservationBills = function(params) {
        var url = endpoint + "Accounts/GetReservationBills";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReservationBills"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReservationBills"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReservationCustomerInvoices = function(params) {
        var url = endpoint + "Accounts/GetReservationCustomerInvoices";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReservationCustomerInvoices"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReservationCustomerInvoices"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReservationFolios = function(params) {
        var url = endpoint + "Accounts/GetReservationFolios";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReservationFolios"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReservationFolios"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReservationInclusiveRoomTotal = function(params) {
        var url = endpoint + "Accounts/GetReservationInclusiveRoomTotal";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReservationInclusiveRoomTotal"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReservationInclusiveRoomTotal"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReservationInvoices = function(params) {
        var url = endpoint + "Accounts/GetReservationInvoices";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReservationInvoices"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReservationInvoices"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReservationReceipts = function(params) {
        var url = endpoint + "Accounts/GetReservationReceipts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReservationReceipts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReservationReceipts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetReservationTransactions = function(params) {
        var url = endpoint + "Accounts/GetReservationTransactions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetReservationTransactions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetReservationTransactions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetRevenuePeriodAggregates = function(params) {
        var url = endpoint + "Accounts/GetRevenuePeriodAggregates";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetRevenuePeriodAggregates"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetRevenuePeriodAggregates"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetRevenuePeriodChargeBreakdown = function(params) {
        var url = endpoint + "Accounts/GetRevenuePeriodChargeBreakdown";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetRevenuePeriodChargeBreakdown"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetRevenuePeriodChargeBreakdown"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetRevenuePeriodCharges = function(params) {
        var url = endpoint + "Accounts/GetRevenuePeriodCharges";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetRevenuePeriodCharges"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetRevenuePeriodCharges"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetRoomReservationAdditionalTaxTotal = function(params) {
        var url = endpoint + "Accounts/GetRoomReservationAdditionalTaxTotal";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetRoomReservationAdditionalTaxTotal"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetRoomReservationAdditionalTaxTotal"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetRoomReservationList = function(params) {
        var url = endpoint + "Accounts/GetRoomReservationList";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetRoomReservationList"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetRoomReservationList"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetRoomServiceCharges = function(params) {
        var url = endpoint + "Accounts/GetRoomServiceCharges";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetRoomServiceCharges"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetRoomServiceCharges"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetTax = function(params) {
        var url = endpoint + "Accounts/GetTax";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetTax"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetTax"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetTaxes = function(params) {
        var url = endpoint + "Accounts/GetTaxes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetTaxes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetTaxes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetTill = function(params) {
        var url = endpoint + "Accounts/GetTill";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetTill"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetTill"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetTills = function(params) {
        var url = endpoint + "Accounts/GetTills";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetTills"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetTills"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetTotalIntervalTurnover = function(params) {
        var url = endpoint + "Accounts/GetTotalIntervalTurnover";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetTotalIntervalTurnover"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetTotalIntervalTurnover"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetTotalPeriodCommission = function(params) {
        var url = endpoint + "Accounts/GetTotalPeriodCommission";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetTotalPeriodCommission"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetTotalPeriodCommission"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetTotalPeriodTurnover = function(params) {
        var url = endpoint + "Accounts/GetTotalPeriodTurnover";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetTotalPeriodTurnover"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetTotalPeriodTurnover"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetTransaction = function(params) {
        var url = endpoint + "Accounts/GetTransaction";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetTransaction"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetTransaction"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsGetTransactionHistory = function(params) {
        var url = endpoint + "Accounts/GetTransactionHistory";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"GetTransactionHistory"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"GetTransactionHistory"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsInspectPeriodDeferrments = function(params) {
        var url = endpoint + "Accounts/InspectPeriodDeferrments";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"InspectPeriodDeferrments"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"InspectPeriodDeferrments"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsInspectShiftDeferrments = function(params) {
        var url = endpoint + "Accounts/InspectShiftDeferrments";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"InspectShiftDeferrments"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"InspectShiftDeferrments"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsIssueCounterCustomerInvoice = function(params) {
        var url = endpoint + "Accounts/IssueCounterCustomerInvoice";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"IssueCounterCustomerInvoice"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"IssueCounterCustomerInvoice"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsIssueCounterInvoice = function(params) {
        var url = endpoint + "Accounts/IssueCounterInvoice";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"IssueCounterInvoice"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"IssueCounterInvoice"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsIssueCounterReceipt = function(params) {
        var url = endpoint + "Accounts/IssueCounterReceipt";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"IssueCounterReceipt"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"IssueCounterReceipt"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsIssueCustomerInvoice = function(params) {
        var url = endpoint + "Accounts/IssueCustomerInvoice";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"IssueCustomerInvoice"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"IssueCustomerInvoice"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsIssueInvoice = function(params) {
        var url = endpoint + "Accounts/IssueInvoice";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"IssueInvoice"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"IssueInvoice"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsIssueReceipt = function(params) {
        var url = endpoint + "Accounts/IssueReceipt";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"IssueReceipt"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"IssueReceipt"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsMarkTransactionForBillingSplit = function(params) {
        var url = endpoint + "Accounts/MarkTransactionForBillingSplit";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"MarkTransactionForBillingSplit"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"MarkTransactionForBillingSplit"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsMonitorJournalIntegrity = function(params) {
        var url = endpoint + "Accounts/MonitorJournalIntegrity";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"MonitorJournalIntegrity"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"MonitorJournalIntegrity"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsNewBillingTransaction = function(params) {
        var url = endpoint + "Accounts/NewBillingTransaction";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"NewBillingTransaction"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"NewBillingTransaction"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsNewFolioTransaction = function(params) {
        var url = endpoint + "Accounts/NewFolioTransaction";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"NewFolioTransaction"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"NewFolioTransaction"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsNewPOSPayment = function(params) {
        var url = endpoint + "Accounts/NewPOSPayment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"NewPOSPayment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"NewPOSPayment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsNewProduct = function(params) {
        var url = endpoint + "Accounts/NewProduct";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"NewProduct"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"NewProduct"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsNewReservationFolio = function(params) {
        var url = endpoint + "Accounts/NewReservationFolio";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"NewReservationFolio"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"NewReservationFolio"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsNewRoomServiceTransaction = function(params) {
        var url = endpoint + "Accounts/NewRoomServiceTransaction";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"NewRoomServiceTransaction"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"NewRoomServiceTransaction"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsNewServiceBill = function(params) {
        var url = endpoint + "Accounts/NewServiceBill";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"NewServiceBill"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"NewServiceBill"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsNewTransaction = function(params) {
        var url = endpoint + "Accounts/NewTransaction";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"NewTransaction"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"NewTransaction"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsPreviewJournalSegment = function(params) {
        var url = endpoint + "Accounts/PreviewJournalSegment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"PreviewJournalSegment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"PreviewJournalSegment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsProduceJournalIntervalTurnoverReport = function(params) {
        var url = endpoint + "Accounts/ProduceJournalIntervalTurnoverReport";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ProduceJournalIntervalTurnoverReport"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ProduceJournalIntervalTurnoverReport"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsProduceJournalIntervalTurnoverReportWithResBreakdown = function(params) {
        var url = endpoint + "Accounts/ProduceJournalIntervalTurnoverReportWithResBreakdown";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ProduceJournalIntervalTurnoverReportWithResBreakdown"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ProduceJournalIntervalTurnoverReportWithResBreakdown"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsProducePeriodTurnoverReport = function(params) {
        var url = endpoint + "Accounts/ProducePeriodTurnoverReport";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ProducePeriodTurnoverReport"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ProducePeriodTurnoverReport"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsProducePeriodTurnoverReportWithResBreakdown = function(params) {
        var url = endpoint + "Accounts/ProducePeriodTurnoverReportWithResBreakdown";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ProducePeriodTurnoverReportWithResBreakdown"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ProducePeriodTurnoverReportWithResBreakdown"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsReCloseBill = function(params) {
        var url = endpoint + "Accounts/ReCloseBill";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ReCloseBill"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ReCloseBill"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsReCloseBillAndSegment = function(params) {
        var url = endpoint + "Accounts/ReCloseBillAndSegment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ReCloseBillAndSegment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ReCloseBillAndSegment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsReCloseJournalSegment = function(params) {
        var url = endpoint + "Accounts/ReCloseJournalSegment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ReCloseJournalSegment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ReCloseJournalSegment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsReOpenBill = function(params) {
        var url = endpoint + "Accounts/ReOpenBill";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ReOpenBill"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ReOpenBill"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsReOpenBillAndSegment = function(params) {
        var url = endpoint + "Accounts/ReOpenBillAndSegment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ReOpenBillAndSegment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ReOpenBillAndSegment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsReOpenJournalSegment = function(params) {
        var url = endpoint + "Accounts/ReOpenJournalSegment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"ReOpenJournalSegment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"ReOpenJournalSegment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsSaveCustomerInvoiceComment = function(params) {
        var url = endpoint + "Accounts/SaveCustomerInvoiceComment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"SaveCustomerInvoiceComment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"SaveCustomerInvoiceComment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsSetTransactionActiveStatus = function(params) {
        var url = endpoint + "Accounts/SetTransactionActiveStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"SetTransactionActiveStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"SetTransactionActiveStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsSetTransactionInvoicingStatus = function(params) {
        var url = endpoint + "Accounts/SetTransactionInvoicingStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"SetTransactionInvoicingStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"SetTransactionInvoicingStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsSplitIntoNewBill = function(params) {
        var url = endpoint + "Accounts/SplitIntoNewBill";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"SplitIntoNewBill"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"SplitIntoNewBill"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.AccountsTransferBillToRoom = function(params) {
        var url = endpoint + "Accounts/TransferBillToRoom";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Accounts"
                        ,"TransferBillToRoom"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Accounts"
                        ,"TransferBillToRoom"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksAssignTaskToStaffMember = function(params) {
        var url = endpoint + "Tasks/AssignTaskToStaffMember";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"AssignTaskToStaffMember"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"AssignTaskToStaffMember"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksChangeRoomCleanStatus = function(params) {
        var url = endpoint + "Tasks/ChangeRoomCleanStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"ChangeRoomCleanStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"ChangeRoomCleanStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksChangeRoomOccupancyStatus = function(params) {
        var url = endpoint + "Tasks/ChangeRoomOccupancyStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"ChangeRoomOccupancyStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"ChangeRoomOccupancyStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksChangeTaskPriority = function(params) {
        var url = endpoint + "Tasks/ChangeTaskPriority";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"ChangeTaskPriority"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"ChangeTaskPriority"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksDeleteStaff = function(params) {
        var url = endpoint + "Tasks/DeleteStaff";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"DeleteStaff"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"DeleteStaff"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksEditStaffPIN = function(params) {
        var url = endpoint + "Tasks/EditStaffPIN";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"EditStaffPIN"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"EditStaffPIN"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksExtGetAllRoomCleaningTasks = function(params) {
        var url = endpoint + "Tasks/ExtGetAllRoomCleaningTasks";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"ExtGetAllRoomCleaningTasks"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"ExtGetAllRoomCleaningTasks"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksExtSetRoomCleaningTaskState = function(params) {
        var url = endpoint + "Tasks/ExtSetRoomCleaningTaskState";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"ExtSetRoomCleaningTaskState"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"ExtSetRoomCleaningTaskState"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetCleaningTasksStaffData = function(params) {
        var url = endpoint + "Tasks/GetCleaningTasksStaffData";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetCleaningTasksStaffData"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetCleaningTasksStaffData"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetCleaningTasksStaffSummary = function(params) {
        var url = endpoint + "Tasks/GetCleaningTasksStaffSummary";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetCleaningTasksStaffSummary"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetCleaningTasksStaffSummary"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetCleaningTaskTypes = function(params) {
        var url = endpoint + "Tasks/GetCleaningTaskTypes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetCleaningTaskTypes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetCleaningTaskTypes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetCleaningTaskWorkflowConfig = function(params) {
        var url = endpoint + "Tasks/GetCleaningTaskWorkflowConfig";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetCleaningTaskWorkflowConfig"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetCleaningTaskWorkflowConfig"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetClearMakeUpRoomConfig = function(params) {
        var url = endpoint + "Tasks/GetClearMakeUpRoomConfig";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetClearMakeUpRoomConfig"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetClearMakeUpRoomConfig"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetExtraReservationTaskMenu = function(params) {
        var url = endpoint + "Tasks/GetExtraReservationTaskMenu";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetExtraReservationTaskMenu"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetExtraReservationTaskMenu"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetHandledStatuses = function(params) {
        var url = endpoint + "Tasks/GetHandledStatuses";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetHandledStatuses"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetHandledStatuses"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetLocationDayCleaningTasks = function(params) {
        var url = endpoint + "Tasks/GetLocationDayCleaningTasks";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetLocationDayCleaningTasks"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetLocationDayCleaningTasks"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetLocationDayTask = function(params) {
        var url = endpoint + "Tasks/GetLocationDayTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetLocationDayTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetLocationDayTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetLocationDayTaskHistory = function(params) {
        var url = endpoint + "Tasks/GetLocationDayTaskHistory";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetLocationDayTaskHistory"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetLocationDayTaskHistory"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetReservationByRoomKeyParams = function(params) {
        var url = endpoint + "Tasks/GetReservationByRoomKeyParams";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetReservationByRoomKeyParams"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetReservationByRoomKeyParams"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetRoomDoNotDisturbStatuses = function(params) {
        var url = endpoint + "Tasks/GetRoomDoNotDisturbStatuses";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetRoomDoNotDisturbStatuses"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetRoomDoNotDisturbStatuses"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetRoomDoNotDisturbStatusID = function(params) {
        var url = endpoint + "Tasks/GetRoomDoNotDisturbStatusID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetRoomDoNotDisturbStatusID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetRoomDoNotDisturbStatusID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetRoomKeyConfigByAPIKey = function(params) {
        var url = endpoint + "Tasks/GetRoomKeyConfigByAPIKey";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetRoomKeyConfigByAPIKey"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetRoomKeyConfigByAPIKey"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetRoomKeyIssueParameters = function(params) {
        var url = endpoint + "Tasks/GetRoomKeyIssueParameters";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetRoomKeyIssueParameters"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetRoomKeyIssueParameters"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetRoomKeyIssuesByRoomReservationID = function(params) {
        var url = endpoint + "Tasks/GetRoomKeyIssuesByRoomReservationID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetRoomKeyIssuesByRoomReservationID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetRoomKeyIssuesByRoomReservationID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetStaff = function(params) {
        var url = endpoint + "Tasks/GetStaff";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetStaff"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetStaff"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetStaffAssignedDayCleaningTasks = function(params) {
        var url = endpoint + "Tasks/GetStaffAssignedDayCleaningTasks";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetStaffAssignedDayCleaningTasks"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetStaffAssignedDayCleaningTasks"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetTaskChecklistItem = function(params) {
        var url = endpoint + "Tasks/GetTaskChecklistItem";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetTaskChecklistItem"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetTaskChecklistItem"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetTaskChecklistItems = function(params) {
        var url = endpoint + "Tasks/GetTaskChecklistItems";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetTaskChecklistItems"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetTaskChecklistItems"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetTaskDataWindow = function(params) {
        var url = endpoint + "Tasks/GetTaskDataWindow";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetTaskDataWindow"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetTaskDataWindow"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetTaskMissingChecklistItems = function(params) {
        var url = endpoint + "Tasks/GetTaskMissingChecklistItems";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetTaskMissingChecklistItems"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetTaskMissingChecklistItems"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGetTaskPriorities = function(params) {
        var url = endpoint + "Tasks/GetTaskPriorities";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GetTaskPriorities"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GetTaskPriorities"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGuestAlterExtraReservationTask = function(params) {
        var url = endpoint + "Tasks/GuestAlterExtraReservationTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GuestAlterExtraReservationTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GuestAlterExtraReservationTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksGuestChangeRoomDoNotDisturbStatus = function(params) {
        var url = endpoint + "Tasks/GuestChangeRoomDoNotDisturbStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"GuestChangeRoomDoNotDisturbStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"GuestChangeRoomDoNotDisturbStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksHandleCleaningStaffShiftEnd = function(params) {
        var url = endpoint + "Tasks/HandleCleaningStaffShiftEnd";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"HandleCleaningStaffShiftEnd"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"HandleCleaningStaffShiftEnd"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksIssueRoomKey = function(params) {
        var url = endpoint + "Tasks/IssueRoomKey";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"IssueRoomKey"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"IssueRoomKey"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksNewStaff = function(params) {
        var url = endpoint + "Tasks/NewStaff";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"NewStaff"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"NewStaff"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksNotifyOutstandingCTMActivations = function(params) {
        var url = endpoint + "Tasks/NotifyOutstandingCTMActivations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"NotifyOutstandingCTMActivations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"NotifyOutstandingCTMActivations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksPumpAllMissingGuestMoveNotifications = function(params) {
        var url = endpoint + "Tasks/PumpAllMissingGuestMoveNotifications";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"PumpAllMissingGuestMoveNotifications"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"PumpAllMissingGuestMoveNotifications"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksQuickCloseCleaningTask = function(params) {
        var url = endpoint + "Tasks/QuickCloseCleaningTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"QuickCloseCleaningTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"QuickCloseCleaningTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksReceptionChangeRoomDoNotDisturbStatus = function(params) {
        var url = endpoint + "Tasks/ReceptionChangeRoomDoNotDisturbStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"ReceptionChangeRoomDoNotDisturbStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"ReceptionChangeRoomDoNotDisturbStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksReturnRoomKey = function(params) {
        var url = endpoint + "Tasks/ReturnRoomKey";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"ReturnRoomKey"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"ReturnRoomKey"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberCheckAllItems = function(params) {
        var url = endpoint + "Tasks/StaffMemberCheckAllItems";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberCheckAllItems"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberCheckAllItems"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberClearRoomBusyHint = function(params) {
        var url = endpoint + "Tasks/StaffMemberClearRoomBusyHint";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberClearRoomBusyHint"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberClearRoomBusyHint"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberCloseCleaningTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberCloseCleaningTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberCloseCleaningTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberCloseCleaningTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberCloseExtraReservationTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberCloseExtraReservationTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberCloseExtraReservationTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberCloseExtraReservationTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberCloseTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberCloseTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberCloseTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberCloseTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberOpenCleaningTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberOpenCleaningTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberOpenCleaningTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberOpenCleaningTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberOpenExtraReservationTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberOpenExtraReservationTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberOpenExtraReservationTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberOpenExtraReservationTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberOpenTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberOpenTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberOpenTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberOpenTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberSetChecklistItemMissing = function(params) {
        var url = endpoint + "Tasks/StaffMemberSetChecklistItemMissing";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberSetChecklistItemMissing"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberSetChecklistItemMissing"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberSetChecklistItemState = function(params) {
        var url = endpoint + "Tasks/StaffMemberSetChecklistItemState";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberSetChecklistItemState"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberSetChecklistItemState"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberSetRoomBusyHint = function(params) {
        var url = endpoint + "Tasks/StaffMemberSetRoomBusyHint";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberSetRoomBusyHint"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberSetRoomBusyHint"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberUncheckAllItems = function(params) {
        var url = endpoint + "Tasks/StaffMemberUncheckAllItems";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberUncheckAllItems"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberUncheckAllItems"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberUndoCloseCleaningTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberUndoCloseCleaningTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberUndoCloseCleaningTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberUndoCloseCleaningTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberUndoCloseExtraReservationTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberUndoCloseExtraReservationTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberUndoCloseExtraReservationTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberUndoCloseExtraReservationTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberUndoCloseTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberUndoCloseTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberUndoCloseTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberUndoCloseTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberUndoOpenCleaningTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberUndoOpenCleaningTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberUndoOpenCleaningTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberUndoOpenCleaningTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberUndoOpenExtraReservationTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberUndoOpenExtraReservationTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberUndoOpenExtraReservationTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberUndoOpenExtraReservationTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.TasksStaffMemberUndoOpenTask = function(params) {
        var url = endpoint + "Tasks/StaffMemberUndoOpenTask";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Tasks"
                        ,"StaffMemberUndoOpenTask"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Tasks"
                        ,"StaffMemberUndoOpenTask"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaActivateHotelAccountFromNearbyPlace = function(params) {
        var url = endpoint + "Ota/ActivateHotelAccountFromNearbyPlace";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"ActivateHotelAccountFromNearbyPlace"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"ActivateHotelAccountFromNearbyPlace"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaAddgplace = function(params) {
        var url = endpoint + "Ota/Addgplace";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"Addgplace"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"Addgplace"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaAddGPlaceFromNearbyPlace = function(params) {
        var url = endpoint + "Ota/AddGPlaceFromNearbyPlace";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"AddGPlaceFromNearbyPlace"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"AddGPlaceFromNearbyPlace"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaAddHotelDoc = function(params) {
        var url = endpoint + "Ota/AddHotelDoc";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"AddHotelDoc"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"AddHotelDoc"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaAddHotelMap = function(params) {
        var url = endpoint + "Ota/AddHotelMap";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"AddHotelMap"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"AddHotelMap"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaAddHotelPhoto = function(params) {
        var url = endpoint + "Ota/AddHotelPhoto";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"AddHotelPhoto"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"AddHotelPhoto"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaAssignHotelPhotoToRoomType = function(params) {
        var url = endpoint + "Ota/AssignHotelPhotoToRoomType";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"AssignHotelPhotoToRoomType"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"AssignHotelPhotoToRoomType"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaAssignHotelToChain = function(params) {
        var url = endpoint + "Ota/AssignHotelToChain";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"AssignHotelToChain"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"AssignHotelToChain"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaBuildHotelRatings = function(params) {
        var url = endpoint + "Ota/BuildHotelRatings";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"BuildHotelRatings"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"BuildHotelRatings"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaBuildSearchLocations = function(params) {
        var url = endpoint + "Ota/BuildSearchLocations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"BuildSearchLocations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"BuildSearchLocations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaCheckHotelConfig = function(params) {
        var url = endpoint + "Ota/CheckHotelConfig";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"CheckHotelConfig"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"CheckHotelConfig"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaClearSubPayPeriod = function(params) {
        var url = endpoint + "Ota/ClearSubPayPeriod";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"ClearSubPayPeriod"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"ClearSubPayPeriod"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaCorres_GetSelectedHotelCor = function(params) {
        var url = endpoint + "Ota/Corres_GetSelectedHotelCor";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"Corres_GetSelectedHotelCor"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"Corres_GetSelectedHotelCor"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaCorresGetSelectedHotelCor = function(params) {
        var url = endpoint + "Ota/CorresGetSelectedHotelCor";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"CorresGetSelectedHotelCor"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"CorresGetSelectedHotelCor"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaCorresInsertCorrLetter = function(params) {
        var url = endpoint + "Ota/CorresInsertCorrLetter";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"CorresInsertCorrLetter"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"CorresInsertCorrLetter"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaDeleteHotelDoc = function(params) {
        var url = endpoint + "Ota/DeleteHotelDoc";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"DeleteHotelDoc"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"DeleteHotelDoc"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaDeleteHotelMap = function(params) {
        var url = endpoint + "Ota/DeleteHotelMap";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"DeleteHotelMap"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"DeleteHotelMap"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaDeleteHotelPhoto = function(params) {
        var url = endpoint + "Ota/DeleteHotelPhoto";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"DeleteHotelPhoto"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"DeleteHotelPhoto"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaDeleteLocationGeoCode = function(params) {
        var url = endpoint + "Ota/DeleteLocationGeoCode";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"DeleteLocationGeoCode"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"DeleteLocationGeoCode"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaEditHotelChainInfo = function(params) {
        var url = endpoint + "Ota/EditHotelChainInfo";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"EditHotelChainInfo"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"EditHotelChainInfo"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaEditHotelChainPassword = function(params) {
        var url = endpoint + "Ota/EditHotelChainPassword";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"EditHotelChainPassword"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"EditHotelChainPassword"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaEditHotelDescription = function(params) {
        var url = endpoint + "Ota/EditHotelDescription";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"EditHotelDescription"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"EditHotelDescription"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaEditHotelDetails = function(params) {
        var url = endpoint + "Ota/EditHotelDetails";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"EditHotelDetails"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"EditHotelDetails"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaEditHotelDocDescription = function(params) {
        var url = endpoint + "Ota/EditHotelDocDescription";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"EditHotelDocDescription"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"EditHotelDocDescription"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaEditHotelEngineServiceTemplate = function(params) {
        var url = endpoint + "Ota/EditHotelEngineServiceTemplate";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"EditHotelEngineServiceTemplate"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"EditHotelEngineServiceTemplate"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaEditHotelMapDescription = function(params) {
        var url = endpoint + "Ota/EditHotelMapDescription";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"EditHotelMapDescription"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"EditHotelMapDescription"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaEditHotelPhotoDescription = function(params) {
        var url = endpoint + "Ota/EditHotelPhotoDescription";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"EditHotelPhotoDescription"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"EditHotelPhotoDescription"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaEditHotelRouteDescription = function(params) {
        var url = endpoint + "Ota/EditHotelRouteDescription";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"EditHotelRouteDescription"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"EditHotelRouteDescription"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaExtractSearchLocationXML = function(params) {
        var url = endpoint + "Ota/ExtractSearchLocationXML";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"ExtractSearchLocationXML"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"ExtractSearchLocationXML"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaFeedbackInsert = function(params) {
        var url = endpoint + "Ota/FeedbackInsert";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"FeedbackInsert"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"FeedbackInsert"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaFinalizeGooglePromoSync = function(params) {
        var url = endpoint + "Ota/FinalizeGooglePromoSync";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"FinalizeGooglePromoSync"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"FinalizeGooglePromoSync"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaFinalizeGooglePropertySync = function(params) {
        var url = endpoint + "Ota/FinalizeGooglePropertySync";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"FinalizeGooglePropertySync"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"FinalizeGooglePropertySync"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetAccommodationStatuses = function(params) {
        var url = endpoint + "Ota/GetAccommodationStatuses";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetAccommodationStatuses"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetAccommodationStatuses"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetAccommodationTypes = function(params) {
        var url = endpoint + "Ota/GetAccommodationTypes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetAccommodationTypes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetAccommodationTypes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetActiveConcentricRun = function(params) {
        var url = endpoint + "Ota/GetActiveConcentricRun";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetActiveConcentricRun"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetActiveConcentricRun"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetActiveConcentricSearch = function(params) {
        var url = endpoint + "Ota/GetActiveConcentricSearch";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetActiveConcentricSearch"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetActiveConcentricSearch"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetActiveCountries = function(params) {
        var url = endpoint + "Ota/GetActiveCountries";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetActiveCountries"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetActiveCountries"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetAllHotelPhotosAndDescriptions = function(params) {
        var url = endpoint + "Ota/GetAllHotelPhotosAndDescriptions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetAllHotelPhotosAndDescriptions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetAllHotelPhotosAndDescriptions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetBNPartner = function(params) {
        var url = endpoint + "Ota/GetBNPartner";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetBNPartner"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetBNPartner"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetCCTypeNameByID = function(params) {
        var url = endpoint + "Ota/GetCCTypeNameByID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetCCTypeNameByID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetCCTypeNameByID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetChainReservationList = function(params) {
        var url = endpoint + "Ota/GetChainReservationList";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetChainReservationList"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetChainReservationList"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetCountryLocationsAll = function(params) {
        var url = endpoint + "Ota/GetCountryLocationsAll";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetCountryLocationsAll"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetCountryLocationsAll"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetCountryNameByID = function(params) {
        var url = endpoint + "Ota/GetCountryNameByID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetCountryNameByID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetCountryNameByID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetCurrencies = function(params) {
        var url = endpoint + "Ota/GetCurrencies";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetCurrencies"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetCurrencies"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetCurrencyByID = function(params) {
        var url = endpoint + "Ota/GetCurrencyByID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetCurrencyByID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetCurrencyByID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetCustomerPasswordByGuest = function(params) {
        var url = endpoint + "Ota/GetCustomerPasswordByGuest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetCustomerPasswordByGuest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetCustomerPasswordByGuest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetCustomerReviews = function(params) {
        var url = endpoint + "Ota/GetCustomerReviews";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetCustomerReviews"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetCustomerReviews"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetDocTypes = function(params) {
        var url = endpoint + "Ota/GetDocTypes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetDocTypes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetDocTypes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetGoogleHotels = function(params) {
        var url = endpoint + "Ota/GetGoogleHotels";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetGoogleHotels"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetGoogleHotels"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetGooglePropertyID = function(params) {
        var url = endpoint + "Ota/GetGooglePropertyID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetGooglePropertyID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetGooglePropertyID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetGuestCategories = function(params) {
        var url = endpoint + "Ota/GetGuestCategories";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetGuestCategories"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetGuestCategories"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelByID = function(params) {
        var url = endpoint + "Ota/GetHotelByID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelByID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelByID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelChainHotelList = function(params) {
        var url = endpoint + "Ota/GetHotelChainHotelList";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelChainHotelList"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelChainHotelList"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelChainInfo = function(params) {
        var url = endpoint + "Ota/GetHotelChainInfo";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelChainInfo"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelChainInfo"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelChainXMLProviders = function(params) {
        var url = endpoint + "Ota/GetHotelChainXMLProviders";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelChainXMLProviders"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelChainXMLProviders"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelCPolicy = function(params) {
        var url = endpoint + "Ota/GetHotelCPolicy";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelCPolicy"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelCPolicy"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelCPolicyFreeUntil = function(params) {
        var url = endpoint + "Ota/GetHotelCPolicyFreeUntil";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelCPolicyFreeUntil"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelCPolicyFreeUntil"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelDescriptions = function(params) {
        var url = endpoint + "Ota/GetHotelDescriptions";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelDescriptions"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelDescriptions"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelDetails = function(params) {
        var url = endpoint + "Ota/GetHotelDetails";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelDetails"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelDetails"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelDiscountSettingsStatus = function(params) {
        var url = endpoint + "Ota/GetHotelDiscountSettingsStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelDiscountSettingsStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelDiscountSettingsStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelDistanceFromCenter = function(params) {
        var url = endpoint + "Ota/GetHotelDistanceFromCenter";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelDistanceFromCenter"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelDistanceFromCenter"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelDocs = function(params) {
        var url = endpoint + "Ota/GetHotelDocs";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelDocs"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelDocs"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelEngineServiceTemplateSettings = function(params) {
        var url = endpoint + "Ota/GetHotelEngineServiceTemplateSettings";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelEngineServiceTemplateSettings"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelEngineServiceTemplateSettings"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelFacilities = function(params) {
        var url = endpoint + "Ota/GetHotelFacilities";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelFacilities"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelFacilities"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelFacilitiesAll = function(params) {
        var url = endpoint + "Ota/GetHotelFacilitiesAll";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelFacilitiesAll"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelFacilitiesAll"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelFeedback = function(params) {
        var url = endpoint + "Ota/GetHotelFeedback";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelFeedback"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelFeedback"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelInfo = function(params) {
        var url = endpoint + "Ota/GetHotelInfo";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelInfo"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelInfo"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelMemberDiscountPeriods = function(params) {
        var url = endpoint + "Ota/GetHotelMemberDiscountPeriods";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelMemberDiscountPeriods"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelMemberDiscountPeriods"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelPassword = function(params) {
        var url = endpoint + "Ota/GetHotelPassword";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelPassword"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelPassword"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelPhotos = function(params) {
        var url = endpoint + "Ota/GetHotelPhotos";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelPhotos"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelPhotos"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelPolicies = function(params) {
        var url = endpoint + "Ota/GetHotelPolicies";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelPolicies"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelPolicies"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelRating = function(params) {
        var url = endpoint + "Ota/GetHotelRating";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelRating"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelRating"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelReservationsEmail = function(params) {
        var url = endpoint + "Ota/GetHotelReservationsEmail";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelReservationsEmail"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelReservationsEmail"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelsNeedingDiscountSettingsNotif = function(params) {
        var url = endpoint + "Ota/GetHotelsNeedingDiscountSettingsNotif";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelsNeedingDiscountSettingsNotif"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelsNeedingDiscountSettingsNotif"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelsNeedingGooglePromoSync = function(params) {
        var url = endpoint + "Ota/GetHotelsNeedingGooglePromoSync";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelsNeedingGooglePromoSync"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelsNeedingGooglePromoSync"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelsNeedingGooglePropertySync = function(params) {
        var url = endpoint + "Ota/GetHotelsNeedingGooglePropertySync";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelsNeedingGooglePropertySync"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelsNeedingGooglePropertySync"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelsNeedingSpotlightSettingsNotif = function(params) {
        var url = endpoint + "Ota/GetHotelsNeedingSpotlightSettingsNotif";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelsNeedingSpotlightSettingsNotif"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelsNeedingSpotlightSettingsNotif"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelSpotlightDiscounts = function(params) {
        var url = endpoint + "Ota/GetHotelSpotlightDiscounts";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelSpotlightDiscounts"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelSpotlightDiscounts"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelSpotlightPriceStatus = function(params) {
        var url = endpoint + "Ota/GetHotelSpotlightPriceStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelSpotlightPriceStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelSpotlightPriceStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelsWithGoogleSyncFailure = function(params) {
        var url = endpoint + "Ota/GetHotelsWithGoogleSyncFailure";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelsWithGoogleSyncFailure"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelsWithGoogleSyncFailure"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetHotelXMLProvider = function(params) {
        var url = endpoint + "Ota/GetHotelXMLProvider";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetHotelXMLProvider"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetHotelXMLProvider"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetLocationGeoCode = function(params) {
        var url = endpoint + "Ota/GetLocationGeoCode";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetLocationGeoCode"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetLocationGeoCode"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetLocationGeoCodeDetails = function(params) {
        var url = endpoint + "Ota/GetLocationGeoCodeDetails";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetLocationGeoCodeDetails"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetLocationGeoCodeDetails"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetLocationGeoCodeIDFromGPlaceID = function(params) {
        var url = endpoint + "Ota/GetLocationGeoCodeIDFromGPlaceID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetLocationGeoCodeIDFromGPlaceID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetLocationGeoCodeIDFromGPlaceID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetLocationsByNameFragment = function(params) {
        var url = endpoint + "Ota/GetLocationsByNameFragment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetLocationsByNameFragment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetLocationsByNameFragment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetLocationsHotels = function(params) {
        var url = endpoint + "Ota/GetLocationsHotels";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetLocationsHotels"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetLocationsHotels"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetLocationVAT = function(params) {
        var url = endpoint + "Ota/GetLocationVAT";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetLocationVAT"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetLocationVAT"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetMatchingHotels = function(params) {
        var url = endpoint + "Ota/GetMatchingHotels";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetMatchingHotels"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetMatchingHotels"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetMLSearchLocations = function(params) {
        var url = endpoint + "Ota/GetMLSearchLocations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetMLSearchLocations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetMLSearchLocations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetNearbyPlaceDetails = function(params) {
        var url = endpoint + "Ota/GetNearbyPlaceDetails";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetNearbyPlaceDetails"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetNearbyPlaceDetails"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetNearbyPlacesNeedingEmail = function(params) {
        var url = endpoint + "Ota/GetNearbyPlacesNeedingEmail";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetNearbyPlacesNeedingEmail"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetNearbyPlacesNeedingEmail"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetNewUnpublishedHotels = function(params) {
        var url = endpoint + "Ota/GetNewUnpublishedHotels";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetNewUnpublishedHotels"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetNewUnpublishedHotels"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetOfferTypeDetails = function(params) {
        var url = endpoint + "Ota/GetOfferTypeDetails";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetOfferTypeDetails"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetOfferTypeDetails"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetOutstandingGoogleScheduleItems = function(params) {
        var url = endpoint + "Ota/GetOutstandingGoogleScheduleItems";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetOutstandingGoogleScheduleItems"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetOutstandingGoogleScheduleItems"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetPasswordCustomer = function(params) {
        var url = endpoint + "Ota/GetPasswordCustomer";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetPasswordCustomer"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetPasswordCustomer"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetPasswordHotel = function(params) {
        var url = endpoint + "Ota/GetPasswordHotel";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetPasswordHotel"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetPasswordHotel"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetPhotosByHotelID = function(params) {
        var url = endpoint + "Ota/GetPhotosByHotelID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetPhotosByHotelID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetPhotosByHotelID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetRegisteredProperty = function(params) {
        var url = endpoint + "Ota/GetRegisteredProperty";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetRegisteredProperty"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetRegisteredProperty"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetRoomTypeDeletionWarningInHotelNativeLang = function(params) {
        var url = endpoint + "Ota/GetRoomTypeDeletionWarningInHotelNativeLang";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetRoomTypeDeletionWarningInHotelNativeLang"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetRoomTypeDeletionWarningInHotelNativeLang"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetRoomTypeNames = function(params) {
        var url = endpoint + "Ota/GetRoomTypeNames";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetRoomTypeNames"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetRoomTypeNames"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetRoomTypeNamesAll = function(params) {
        var url = endpoint + "Ota/GetRoomTypeNamesAll";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetRoomTypeNamesAll"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetRoomTypeNamesAll"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetRoomTypePhotoDescriptionsAll = function(params) {
        var url = endpoint + "Ota/GetRoomTypePhotoDescriptionsAll";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetRoomTypePhotoDescriptionsAll"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetRoomTypePhotoDescriptionsAll"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetRoomTypePhotos = function(params) {
        var url = endpoint + "Ota/GetRoomTypePhotos";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetRoomTypePhotos"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetRoomTypePhotos"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetRoomTypesCM = function(params) {
        var url = endpoint + "Ota/GetRoomTypesCM";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetRoomTypesCM"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetRoomTypesCM"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetSearchLocationsByNameFragment = function(params) {
        var url = endpoint + "Ota/GetSearchLocationsByNameFragment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetSearchLocationsByNameFragment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetSearchLocationsByNameFragment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetStripePaymentStatus = function(params) {
        var url = endpoint + "Ota/GetStripePaymentStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetStripePaymentStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetStripePaymentStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetSubPayPeriods = function(params) {
        var url = endpoint + "Ota/GetSubPayPeriods";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetSubPayPeriods"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetSubPayPeriods"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetTopGPlaceNeedingTranslation = function(params) {
        var url = endpoint + "Ota/GetTopGPlaceNeedingTranslation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetTopGPlaceNeedingTranslation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetTopGPlaceNeedingTranslation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetTopLocationGeoCodeForSearchLocID = function(params) {
        var url = endpoint + "Ota/GetTopLocationGeoCodeForSearchLocID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetTopLocationGeoCodeForSearchLocID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetTopLocationGeoCodeForSearchLocID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetTopSearchLocIDForLocationGeoCode = function(params) {
        var url = endpoint + "Ota/GetTopSearchLocIDForLocationGeoCode";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetTopSearchLocIDForLocationGeoCode"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetTopSearchLocIDForLocationGeoCode"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetTravelPurposes = function(params) {
        var url = endpoint + "Ota/GetTravelPurposes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetTravelPurposes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetTravelPurposes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetUnverifiedLocationGeoCodeHotels = function(params) {
        var url = endpoint + "Ota/GetUnverifiedLocationGeoCodeHotels";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetUnverifiedLocationGeoCodeHotels"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetUnverifiedLocationGeoCodeHotels"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGetUnverifiedLocationGeoCodes = function(params) {
        var url = endpoint + "Ota/GetUnverifiedLocationGeoCodes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GetUnverifiedLocationGeoCodes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GetUnverifiedLocationGeoCodes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaGrantOrGetPMSAPIKey = function(params) {
        var url = endpoint + "Ota/GrantOrGetPMSAPIKey";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"GrantOrGetPMSAPIKey"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"GrantOrGetPMSAPIKey"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaHotelBelongsToChain = function(params) {
        var url = endpoint + "Ota/HotelBelongsToChain";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"HotelBelongsToChain"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"HotelBelongsToChain"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaHotelHasEngineTemplate = function(params) {
        var url = endpoint + "Ota/HotelHasEngineTemplate";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"HotelHasEngineTemplate"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"HotelHasEngineTemplate"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaHotelHasXMLProvider = function(params) {
        var url = endpoint + "Ota/HotelHasXMLProvider";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"HotelHasXMLProvider"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"HotelHasXMLProvider"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaHotelNeedsDiscountSettingsAction = function(params) {
        var url = endpoint + "Ota/HotelNeedsDiscountSettingsAction";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"HotelNeedsDiscountSettingsAction"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"HotelNeedsDiscountSettingsAction"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaIncrementBNPartnerRequestID = function(params) {
        var url = endpoint + "Ota/IncrementBNPartnerRequestID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"IncrementBNPartnerRequestID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"IncrementBNPartnerRequestID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaInitGooglePromoSync = function(params) {
        var url = endpoint + "Ota/InitGooglePromoSync";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"InitGooglePromoSync"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"InitGooglePromoSync"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaInitGoogleProperySync = function(params) {
        var url = endpoint + "Ota/InitGoogleProperySync";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"InitGoogleProperySync"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"InitGoogleProperySync"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaLogCMRequest = function(params) {
        var url = endpoint + "Ota/LogCMRequest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"LogCMRequest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"LogCMRequest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaMakeOTAPublishRequest = function(params) {
        var url = endpoint + "Ota/MakeOTAPublishRequest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"MakeOTAPublishRequest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"MakeOTAPublishRequest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaMarkConcentricRunQueryAsDone = function(params) {
        var url = endpoint + "Ota/MarkConcentricRunQueryAsDone";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"MarkConcentricRunQueryAsDone"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"MarkConcentricRunQueryAsDone"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaMarkHotelAsRetrievedByGoogle = function(params) {
        var url = endpoint + "Ota/MarkHotelAsRetrievedByGoogle";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"MarkHotelAsRetrievedByGoogle"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"MarkHotelAsRetrievedByGoogle"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaMarkReservationFromGoogle = function(params) {
        var url = endpoint + "Ota/MarkReservationFromGoogle";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"MarkReservationFromGoogle"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"MarkReservationFromGoogle"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtamlGetAllLocationGeoCodeNames = function(params) {
        var url = endpoint + "Ota/mlGetAllLocationGeoCodeNames";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"mlGetAllLocationGeoCodeNames"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"mlGetAllLocationGeoCodeNames"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtamlGetAllSearchLocationNames = function(params) {
        var url = endpoint + "Ota/mlGetAllSearchLocationNames";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"mlGetAllSearchLocationNames"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"mlGetAllSearchLocationNames"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtamlGetGuestCategory = function(params) {
        var url = endpoint + "Ota/mlGetGuestCategory";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"mlGetGuestCategory"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"mlGetGuestCategory"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtamlGetTravelPurposes = function(params) {
        var url = endpoint + "Ota/mlGetTravelPurposes";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"mlGetTravelPurposes"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"mlGetTravelPurposes"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaNewRegisterHotel = function(params) {
        var url = endpoint + "Ota/NewRegisterHotel";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"NewRegisterHotel"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"NewRegisterHotel"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaNewRegisterHotelCheck = function(params) {
        var url = endpoint + "Ota/NewRegisterHotelCheck";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"NewRegisterHotelCheck"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"NewRegisterHotelCheck"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaNewStripePayment = function(params) {
        var url = endpoint + "Ota/NewStripePayment";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"NewStripePayment"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"NewStripePayment"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaNotifyDiscountSettingsChange = function(params) {
        var url = endpoint + "Ota/NotifyDiscountSettingsChange";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"NotifyDiscountSettingsChange"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"NotifyDiscountSettingsChange"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaNotifyNewHotelChainAssignments = function(params) {
        var url = endpoint + "Ota/NotifyNewHotelChainAssignments";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"NotifyNewHotelChainAssignments"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"NotifyNewHotelChainAssignments"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaNotifyOutstandingPMSActivations = function(params) {
        var url = endpoint + "Ota/NotifyOutstandingPMSActivations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"NotifyOutstandingPMSActivations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"NotifyOutstandingPMSActivations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaNotifySpotlightSettingsChange = function(params) {
        var url = endpoint + "Ota/NotifySpotlightSettingsChange";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"NotifySpotlightSettingsChange"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"NotifySpotlightSettingsChange"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaNudgeHotelDocSortOrder = function(params) {
        var url = endpoint + "Ota/NudgeHotelDocSortOrder";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"NudgeHotelDocSortOrder"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"NudgeHotelDocSortOrder"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaNudgeHotelMapsSortOrder = function(params) {
        var url = endpoint + "Ota/NudgeHotelMapsSortOrder";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"NudgeHotelMapsSortOrder"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"NudgeHotelMapsSortOrder"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaNudgeHotelPhotoSortOrder = function(params) {
        var url = endpoint + "Ota/NudgeHotelPhotoSortOrder";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"NudgeHotelPhotoSortOrder"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"NudgeHotelPhotoSortOrder"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaPopulateGooglePriceSchdeule = function(params) {
        var url = endpoint + "Ota/PopulateGooglePriceSchdeule";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"PopulateGooglePriceSchdeule"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"PopulateGooglePriceSchdeule"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaPopulateUnverifiedLocationGeoCodeNames = function(params) {
        var url = endpoint + "Ota/PopulateUnverifiedLocationGeoCodeNames";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"PopulateUnverifiedLocationGeoCodeNames"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"PopulateUnverifiedLocationGeoCodeNames"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaPropagateCancellationToStardeck = function(params) {
        var url = endpoint + "Ota/PropagateCancellationToStardeck";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"PropagateCancellationToStardeck"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"PropagateCancellationToStardeck"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaPropagateReservationToStardeck = function(params) {
        var url = endpoint + "Ota/PropagateReservationToStardeck";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"PropagateReservationToStardeck"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"PropagateReservationToStardeck"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaPropagateRoomCancellationToStardeck = function(params) {
        var url = endpoint + "Ota/PropagateRoomCancellationToStardeck";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"PropagateRoomCancellationToStardeck"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"PropagateRoomCancellationToStardeck"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaPublishHotel = function(params) {
        var url = endpoint + "Ota/PublishHotel";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"PublishHotel"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"PublishHotel"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaQuestionaireIns = function(params) {
        var url = endpoint + "Ota/QuestionaireIns";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"QuestionaireIns"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"QuestionaireIns"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaRecordGooglePriceCheckAttempt = function(params) {
        var url = endpoint + "Ota/RecordGooglePriceCheckAttempt";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"RecordGooglePriceCheckAttempt"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"RecordGooglePriceCheckAttempt"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaRecordGooglePriceCheckResult = function(params) {
        var url = endpoint + "Ota/RecordGooglePriceCheckResult";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"RecordGooglePriceCheckResult"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"RecordGooglePriceCheckResult"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaRegisterHotelDocFileName = function(params) {
        var url = endpoint + "Ota/RegisterHotelDocFileName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"RegisterHotelDocFileName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"RegisterHotelDocFileName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaRegisterHotelMapFileName = function(params) {
        var url = endpoint + "Ota/RegisterHotelMapFileName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"RegisterHotelMapFileName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"RegisterHotelMapFileName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaRegisterHotelPhotoFileName = function(params) {
        var url = endpoint + "Ota/RegisterHotelPhotoFileName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"RegisterHotelPhotoFileName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"RegisterHotelPhotoFileName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaRegisterWebException = function(params) {
        var url = endpoint + "Ota/RegisterWebException";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"RegisterWebException"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"RegisterWebException"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaRegisterWebExceptionExtended = function(params) {
        var url = endpoint + "Ota/RegisterWebExceptionExtended";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"RegisterWebExceptionExtended"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"RegisterWebExceptionExtended"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaResetHotelOTAConfirmations = function(params) {
        var url = endpoint + "Ota/ResetHotelOTAConfirmations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"ResetHotelOTAConfirmations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"ResetHotelOTAConfirmations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaSaveHotelDescriptionViaGoogle = function(params) {
        var url = endpoint + "Ota/SaveHotelDescriptionViaGoogle";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"SaveHotelDescriptionViaGoogle"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"SaveHotelDescriptionViaGoogle"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaSelectMaps = function(params) {
        var url = endpoint + "Ota/SelectMaps";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"SelectMaps"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"SelectMaps"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaSetHotelDiscountSettingsStatus = function(params) {
        var url = endpoint + "Ota/SetHotelDiscountSettingsStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"SetHotelDiscountSettingsStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"SetHotelDiscountSettingsStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaSetHotelSpotlightPriceStatus = function(params) {
        var url = endpoint + "Ota/SetHotelSpotlightPriceStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"SetHotelSpotlightPriceStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"SetHotelSpotlightPriceStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaStoreNearbyPlacePhoto = function(params) {
        var url = endpoint + "Ota/StoreNearbyPlacePhoto";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"StoreNearbyPlacePhoto"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"StoreNearbyPlacePhoto"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaStoreNearbyPlaceResult = function(params) {
        var url = endpoint + "Ota/StoreNearbyPlaceResult";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"StoreNearbyPlaceResult"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"StoreNearbyPlaceResult"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaUnpublishHotel = function(params) {
        var url = endpoint + "Ota/UnpublishHotel";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"UnpublishHotel"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"UnpublishHotel"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaUpdateFacility = function(params) {
        var url = endpoint + "Ota/UpdateFacility";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"UpdateFacility"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"UpdateFacility"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaUpdateGPlaceMLNameCollection = function(params) {
        var url = endpoint + "Ota/UpdateGPlaceMLNameCollection";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"UpdateGPlaceMLNameCollection"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"UpdateGPlaceMLNameCollection"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaUpdateNearbyPlacesEmail = function(params) {
        var url = endpoint + "Ota/UpdateNearbyPlacesEmail";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"UpdateNearbyPlacesEmail"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"UpdateNearbyPlacesEmail"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaUpdateStripePaymentStatus = function(params) {
        var url = endpoint + "Ota/UpdateStripePaymentStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"UpdateStripePaymentStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"UpdateStripePaymentStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaUpdateViaCM = function(params) {
        var url = endpoint + "Ota/UpdateViaCM";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"UpdateViaCM"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"UpdateViaCM"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaVerifyGoogleTranslateLimit = function(params) {
        var url = endpoint + "Ota/VerifyGoogleTranslateLimit";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"VerifyGoogleTranslateLimit"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"VerifyGoogleTranslateLimit"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaVerifyLocationGeoCode = function(params) {
        var url = endpoint + "Ota/VerifyLocationGeoCode";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"VerifyLocationGeoCode"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"VerifyLocationGeoCode"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.OtaVerifyNearbyPlaceActivationStatus = function(params) {
        var url = endpoint + "Ota/VerifyNearbyPlaceActivationStatus";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Ota"
                        ,"VerifyNearbyPlaceActivationStatus"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Ota"
                        ,"VerifyNearbyPlaceActivationStatus"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalAddGlocalGeoLocation = function(params) {
        var url = endpoint + "Glocal/AddGlocalGeoLocation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"AddGlocalGeoLocation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"AddGlocalGeoLocation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalAddUserLanguage = function(params) {
        var url = endpoint + "Glocal/AddUserLanguage";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"AddUserLanguage"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"AddUserLanguage"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalAddUserPhoto = function(params) {
        var url = endpoint + "Glocal/AddUserPhoto";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"AddUserPhoto"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"AddUserPhoto"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalAddUserProfilePicture = function(params) {
        var url = endpoint + "Glocal/AddUserProfilePicture";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"AddUserProfilePicture"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"AddUserProfilePicture"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalAlertGlocalSignUp = function(params) {
        var url = endpoint + "Glocal/AlertGlocalSignUp";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"AlertGlocalSignUp"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"AlertGlocalSignUp"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalDeleteUserPicture = function(params) {
        var url = endpoint + "Glocal/DeleteUserPicture";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"DeleteUserPicture"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"DeleteUserPicture"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalEditGlocalDetails = function(params) {
        var url = endpoint + "Glocal/EditGlocalDetails";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"EditGlocalDetails"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"EditGlocalDetails"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalEditUserPictureDescription = function(params) {
        var url = endpoint + "Glocal/EditUserPictureDescription";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"EditUserPictureDescription"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"EditUserPictureDescription"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetEventsByLocationGeoCodeID = function(params) {
        var url = endpoint + "Glocal/GetEventsByLocationGeoCodeID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetEventsByLocationGeoCodeID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetEventsByLocationGeoCodeID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetGlocalDetails = function(params) {
        var url = endpoint + "Glocal/GetGlocalDetails";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetGlocalDetails"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetGlocalDetails"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetGlocalGeoLocations = function(params) {
        var url = endpoint + "Glocal/GetGlocalGeoLocations";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetGlocalGeoLocations"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetGlocalGeoLocations"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetGlocalLanguagesByLocationGeoCodeID = function(params) {
        var url = endpoint + "Glocal/GetGlocalLanguagesByLocationGeoCodeID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetGlocalLanguagesByLocationGeoCodeID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetGlocalLanguagesByLocationGeoCodeID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetGlocalLanguagesBySearchLocation = function(params) {
        var url = endpoint + "Glocal/GetGlocalLanguagesBySearchLocation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetGlocalLanguagesBySearchLocation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetGlocalLanguagesBySearchLocation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetGlocalsByLocationGeoCodeID = function(params) {
        var url = endpoint + "Glocal/GetGlocalsByLocationGeoCodeID";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetGlocalsByLocationGeoCodeID"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetGlocalsByLocationGeoCodeID"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetGlocalsBySearchLocation = function(params) {
        var url = endpoint + "Glocal/GetGlocalsBySearchLocation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetGlocalsBySearchLocation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetGlocalsBySearchLocation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetMessages = function(params) {
        var url = endpoint + "Glocal/GetMessages";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetMessages"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetMessages"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetNumUnreadMessages = function(params) {
        var url = endpoint + "Glocal/GetNumUnreadMessages";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetNumUnreadMessages"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetNumUnreadMessages"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetSpokenLanguages = function(params) {
        var url = endpoint + "Glocal/GetSpokenLanguages";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetSpokenLanguages"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetSpokenLanguages"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetUnalertedGlocalSignUps = function(params) {
        var url = endpoint + "Glocal/GetUnalertedGlocalSignUps";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetUnalertedGlocalSignUps"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetUnalertedGlocalSignUps"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetUnalertedUserMessages = function(params) {
        var url = endpoint + "Glocal/GetUnalertedUserMessages";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetUnalertedUserMessages"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetUnalertedUserMessages"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetUserInterests = function(params) {
        var url = endpoint + "Glocal/GetUserInterests";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetUserInterests"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetUserInterests"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetUserInterestsByUser = function(params) {
        var url = endpoint + "Glocal/GetUserInterestsByUser";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetUserInterestsByUser"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetUserInterestsByUser"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetUserLanguages = function(params) {
        var url = endpoint + "Glocal/GetUserLanguages";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetUserLanguages"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetUserLanguages"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalGetUserPictures = function(params) {
        var url = endpoint + "Glocal/GetUserPictures";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"GetUserPictures"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"GetUserPictures"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalIndicateProfilePicture = function(params) {
        var url = endpoint + "Glocal/IndicateProfilePicture";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"IndicateProfilePicture"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"IndicateProfilePicture"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalIndicateUserInterest = function(params) {
        var url = endpoint + "Glocal/IndicateUserInterest";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"IndicateUserInterest"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"IndicateUserInterest"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalMarkMessagesAsRead = function(params) {
        var url = endpoint + "Glocal/MarkMessagesAsRead";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"MarkMessagesAsRead"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"MarkMessagesAsRead"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalMarkMessagesAsReadByUser = function(params) {
        var url = endpoint + "Glocal/MarkMessagesAsReadByUser";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"MarkMessagesAsReadByUser"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"MarkMessagesAsReadByUser"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalMessageGlocal = function(params) {
        var url = endpoint + "Glocal/MessageGlocal";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"MessageGlocal"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"MessageGlocal"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalRegisterGlocal = function(params) {
        var url = endpoint + "Glocal/RegisterGlocal";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"RegisterGlocal"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"RegisterGlocal"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalRegisterUserPhotoFileName = function(params) {
        var url = endpoint + "Glocal/RegisterUserPhotoFileName";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"RegisterUserPhotoFileName"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"RegisterUserPhotoFileName"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalRemoveGlocalGeoLocation = function(params) {
        var url = endpoint + "Glocal/RemoveGlocalGeoLocation";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"RemoveGlocalGeoLocation"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"RemoveGlocalGeoLocation"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalRemoveUserLanguage = function(params) {
        var url = endpoint + "Glocal/RemoveUserLanguage";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"RemoveUserLanguage"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"RemoveUserLanguage"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    exports.GlocalUnregisterGlocal = function(params) {
        var url = endpoint + "Glocal/UnregisterGlocal";

        if ((window.RQueryRESTServiceHelper !== undefined) && params) {
            delete params.RQueryAuthToken;
        }

        if (!params) { params = {}; }

        return $.ajax(
            {
                 url:         url
                ,type:        "POST"
                ,contentType: "application/json"
                ,data:        JSON.stringify(params)
                ,timeout:     rqTimeout
                ,success:     function(jsonResult) {
                    resultHandler(
                         "Glocal"
                        ,"UnregisterGlocal"
                        ,jsonResult
                    );
                }
                ,error:       function(jqXHR, textStatus) {
                    errorHandler(
                         "Glocal"
                        ,"UnregisterGlocal"
                        ,textStatus
                    );
                }
                ,headers: {
                     "RQueryAuthToken": getAuthToken()
                    ,"RQueryAPIKey":    getAPIKey()
                }
            }
        );
    };

    return exports;
};



//////////////////
// WEBPACK FOOTER
// ./src/RQuery/RQueryREST.js
// module id = 401
// module chunks = 0